///* eslint-disable */
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
// import InputMask from 'react-input-mask';
import validator from 'validator';
import moment from 'moment';
import { generatePath } from 'react-router-dom';
import {
    Divider,
    Box,
    Typography,
    Checkbox,
    Button,
    Grid,
    // ListItem,
    // Link,
    Switch,
    AppBar,
    Stack,
    FormControl,
    TextField,
    RadioGroup,
    FormControlLabel,
    Radio,
    FormGroup,
    Backdrop,
    CircularProgress,
    Select,
    MenuItem,
    InputLabel,
    FormHelperText,
} from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { createState, useState, Downgraded } from '@hookstate/core';
import { RouterPrompt } from '../../router/routerPrompt';
import { makeStyles } from '@mui/styles';
// import stores
import { updateModuleState } from '../../stores/eventStore';
import AppConstants from '../../constants/appConstants';
// import utility and constants
import Helper from '../../utility/helper';
import ApiHelper from '../../utility/ApiHelper';
import APIURLConstants from '../../config/config';
import RouteConstants from '../../constants/routeConstants';
// import shared components
import Title from '../../sharedcomponents/title/title';
import {
    useAgentSaveAsDraftState, setAgentShowConfirmPopUp, resetSaveAsDraftState
} from '../../hookState/AgentSaveAsDraftState';
import CustomizedSnackbars from '../../sharedcomponents/snackbar/snackBar';
import ParticipantAutoList from '../../sharedcomponents/participantAutoList/participantAutoList';
import { useAgentState } from '../../hookState/AgentState';
import DetailsComponent from '../../sharedcomponents/detailsComponent/DetailsComponent';
import { FULL_PERMISSION, VIEW_PERMISSION } from '../../constants/Constant';
import PhoneNumber from '../../sharedcomponents/PhoneNumber/phoneNumber';
import MUIDatePicker from '../../sharedcomponents/datePicker';
import ProfileImage from '../../sharedcomponents/profileImage/profileImage';
import UploadImagePopup from '../../sharedcomponents/uploadImage/uploadImagePopup';
import pic from '../../assets/images/pic.svg';
import dayjs from 'dayjs';
// const sex = [
//     {
//         value: 'M',
//         label: 'Male',
//     },
//     {
//         value: 'F',
//         label: 'Female',
//     },
// ];
// const vaccinated = [
//     {
//         value: 1,
//         label: 'Yes',
//     },
//     {
//         value: 0,
//         label: 'No',
//     },
// ];

const useStyles = makeStyles({
    radioLabel: {
        padding: 6,
    }
});
const appBarStyle = {
    mb: 0,
    boxShadow: 'none',
    pt: 1,
    pb: 0,
    pl: 1,
    borderTop: '1px solid #D7D7D7',
    borderBottom: '1px solid #D7D7D7',
    backgroundColor: '#F8F8F8',
    mt: 1
};

const eventState = createState({
    firstName: '',
    lastName: '',
    email: '',
    dob: null,
    contactNo: '',
    eventForm: null,
    mailingAddress: '',
    certifiedagentContactName: '',
    certifiedagentContactNo: '',
    certifiedagentContactEmail: '',
    CertifiedAgentPicUrl: '',
    oldCertifiedAgentPicUrl: '',
    CertifiedAgentPicUrlsrc: '',
    familymemberContactName: '',
    familymemberContactNo: '',
    familymemberEmail: '',
    familymemberPicUrl: '',
    oldFamilymemberPicUrl: '',
    familymemberPicUrlsrc: '',
    personalphysicianContactName: '',
    personalphysicianContactNo: '',
    personalphysicianEmail: '',
    athleticTrainerName: '',
    athleticTrainerCell: '',
    athleticTrainerEmail: '',
    dietRestrictions: '',
    reason: '',
    agentProDayParticipant: "",
    attendingDraftNBA: "",
    cityID: '',
    createdDate: null,
    registrationID: 0,
    addedFor: 0,
    isCertifiedAgentAttend: false,
    isFamilyMemberAttend: false,
    athleticDirectorName: '',
    athleticDirectorEmail: '',
    basketballAdminName: '',
    basketballAdminEmail: '',
    basketballAdminContactNo: '',
    participateInFiveOnFive: '',
    defenceDrills: '',
    requestStatus:'',
    agentRoomRequestAccepted:''
});
const EventRegistration = (props) => {
    // console.log("props",props);
    const agentSaveAsDraftState = useAgentSaveAsDraftState();
    // const history = useHistory();
    // const authState = useAuthState();
    // const eventStateDetail = useEventState();
    const classes = useStyles();
    const state = useState(eventState);
    const agentState = useAgentState();
    const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
    const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
    const createdByUser = Helper.getStorage('userInfo');

    // const agentInfo = Helper.getStorage('agentInfo');
    // const userInfo = Helper.getStorage('userInfo');
    const eventInfo = Helper.getStorage('eventInfo');
    // const tags = Helper.getStorage('userTags');
    const [eventTags, setEventTags] = React.useState([]);
    const moduleIndex = useState(-1);
    const [emailErr, setEmailErr] = React.useState('');
    const [cityID, setCityID] = React.useState();
    const [altEmailErr, setAltEmailErr] = React.useState('');
    const [athEmailErr, setAthEmailErr] = React.useState('');
    const [famMemEmailErr, setFamMemEmailErr] = React.useState('');
    const [phoneError, setPhoneError] = React.useState('');
    const [altPhoneError, setAltPhoneError] = React.useState('');
    const [athleticDirectorNameErr, setAthleticDirectorNameErr] = React.useState('');
    const [athleticDirectorEmailErr, setAthleticDirectorEmailErr] = React.useState('');
    const [basketballAdminNameErr, setBasketballAdminNameErr] = React.useState('');
    const [basketballAdminEmailErr, setBasketballAdminEmailErr] = React.useState('');
    const [basketballAdminContactNoError, setBasketballAdminContactNoError] = React.useState('');
    const [personalphysicianNoError, setpersonalphysicianNoError] = React.useState('');
    const [personalphysicianEmailError, setpersonalphysicianEmailError] = React.useState('');
    const [personalphysicianContactNoError, setpersonalphysicianContactNoError] = React.useState('');
    const [agentRoomRequestError, setAgentRoomRequestError] = React.useState('');

    const [famMemPhoneError, setFamMemPhoneError] = React.useState('');
    const [athPhoneError, setAthPhoneError] = React.useState('');
    const [dobErr, setDOBErr] = React.useState('');
    const [firstNameErr, setFirstNameErr] = React.useState('');
    const [altNameErr, setAltNameErr] = React.useState('');
    const [athNameErr, setAthNameErr] = React.useState('');
    const [famMemNameErr, setFamMemNameErr] = React.useState('');
    const [lasttNameErr, setLastNameErr] = React.useState('');
    const [checkEditPermission, setCheckEditPermission] = React.useState(false);
    const [disableDraftBtn, setDisableDraftBtn] = React.useState(true);
    const [saveAsDraftLoader, setSaveAsDraftLoader] = React.useState(false);
    const [openBackdrop, setOpenBackDrop] = React.useState(false);
    const [showAgentProParticipant, setShowAgentProParticipant] =
        React.useState(false);
    const [agentProParticipantText, setAgentProParticipantText] =
        React.useState(null);
    const [mailingError, setMailingError] = React.useState('');
    const [cities, setCities] = React.useState([]);
    const [reasonErr, setReasonErr] = React.useState('');
    const [disableBtn, setDisableBtn] = React.useState(true);
    const [participantList, setParticipantList] = React.useState(null);
    const [participateInFiveOnFiveErr, setParticipateInFiveOnFiveErr] = React.useState('');
    const [defenceDrillsErr, setDefenceDrillsErr] = React.useState('');
    const openUpload = useState(false);
    const openFamilyMemberUpload = useState(false);
    const [agentProdDayErr, setAgentProdDayErr] = React.useState(false);
    const [attendingNBADraftErr, setAttendingNBADraftErr] = React.useState(false);
    const [eliteConfigEventID, setEliteConfigEventID] = React.useState(0);

    // const [isReason,setIsReason]=React.useState(false);
    //const [eventJSON, setEventJSON] = useState();
    // const [modPermission, setModPermission] = React.useState(null);

    // const [submitButton, setSubmitButton] = React.useState('Submit');
    const [participant, setParticipant] = React.useState(null);
    const [dirty, setDirty] = React.useState(false);
    const [showfnfdnd, setShowfnfdnd] = React.useState(false);

    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    let params = useParams();


    const resetState = (flag) => {
        setFirstNameErr('');
        setLastNameErr('');
        setPhoneError('');
        setEmailErr('');
        setDOBErr('');
        setAltNameErr('');
        setpersonalphysicianNoError('');
        setAltEmailErr('');
        setAltPhoneError('');
        setAthNameErr('');
        setAthPhoneError('');
        setAthEmailErr('');
        setReasonErr('');
        setDOBErr('');
        setMailingError('');
        setAthleticDirectorEmailErr('')
        state.set({
            firstName: agentState.visible.value
                ? agentState.user.get() && agentState.user.get().firstName
                : userInfo.firstName
                    ? userInfo.firstName
                    : '',
            lastName: agentState.visible.value
                ? agentState.user.get() && agentState.user.get().lastName
                : userInfo.lastName
                    ? userInfo.lastName
                    : '',
            email: agentState.visible.value
                ? agentState.user.get() && agentState.user.get().email
                : userInfo.email
                    ? userInfo.email
                    : '',
            dob: null,
            contactNo: '',
            //sex: '',
            //vaccinated: undefined,
            eventForm: null,
            mailingAddress: '',
            certifiedagentContactName: '',
            certifiedagentContactNo: '',
            certifiedagentContactEmail: '',
            CertifiedAgentPicUrl: '',
            oldCertifiedAgentPicUrl: '',
            familymemberContactName: '',
            familymemberContactNo: '',
            familymemberEmail: '',
            familymemberPicUrl: '',
            oldFamilymemberPicUrl: '',
            personalphysicianContactName: '',
            personalphysicianContactNo: '',
            personalphysicianEmail: '',
            athleticTrainerName: '',
            athleticTrainerCell: '',
            athleticTrainerEmail: '',
            dietRestrictions: '',
            reason: '',
            agentProDayParticipant: "",
            attendingDraftNBA: "",
            athleticDirectorName: '',
            athleticDirectorEmail: '',
            basketballAdminName: '',
            basketballAdminEmail: '',
            basketballAdminContactNo: '',
            participateInFiveOnFive: '',
            defenceDrills: '',
            // checkBox1: Boolean(false),
            // checkBox2: Boolean(false),
            // checkBox3: Boolean(false),
            // checkBox4: Boolean(false),
            registrationID: flag ? 0 : state.registrationID.get(),
            addedFor: flag ? 0 : state.addedFor.get(),
            requestStatus:'',
            agentRoomRequestAccepted:''
        });
    };


    useEffect(() => {
        resetState(true);
        resetSaveAsDraftState();

        return () => {
            resetSaveAsDraftState();
        }
    }, [])

    useEffect(() => {
        const getdata = () => {
            if(Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo)){ 
                getParticipantList();
            }
            let city = [];
            ApiHelper.get(APIURLConstants.GET_EVENT_CONFIG(eventInfo.eventID)).then((res) => {
                if (res.data && res.data.length > 0) {
                    // console.log("res.data",res.data); 
                    res.data.map((item) => {
                        if (item.moduleID === AppConstants.EVENT_MODULES.COMBINE_REGISTRATION) { 
                            if (item.key === 'City') {
                                city.push({
                                    key: item.moduleConfigID,
                                    label: item.description,
                                });
                            }
                            if (item.key === 'EliteConfigEventID') {
                                setEliteConfigEventID(item.description === 'true' ? item.eventID : 0) 
                            } 
                        }
                    });
                }
            });
            setCities(city);
            ApiHelper.get(APIURLConstants.GET_TAGS(eventInfo.eventID))
                .then((res) => {
                    setEventTags(res.data);
                })
                .catch((err) => {
                    console.log(err);
                });
        }
        getdata();
        return () => {
            resetState(true);
        }
    }, []);  
    useEffect(() => {
        // console.log("props.modPermission",props.modPermission);
        if (props.modPermission) {
            if (props.modPermission == FULL_PERMISSION) {
                setCheckEditPermission(true);
            } else if (props.modPermission == VIEW_PERMISSION) {
                setCheckEditPermission(false);
            } else {
                setCheckEditPermission(false);
            }
            getModuleDetailsData(props.eventStateDetail.eventDetail);
        }
    }, [props]);

    const getModuleDetailsData = (eventDetail) => {
        if (eventDetail.moduleDetails) {
            const index = eventDetail.moduleDetails.findIndex((element) => {
                if (element.moduleName === 'CombineRegistration') {
                    return true;
                }
            });
            setShowAgentProParticipant(
                eventDetail.moduleDetails[index].showAgentProDayParticipant
            );
            setAgentProParticipantText(eventDetail.moduleDetails[index].agentProDayParticipantText ? JSON.parse(eventDetail.moduleDetails[index].agentProDayParticipantText) : null)
            if (!(Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo) || Helper.isEventStaff(userInfo))) {
                moduleIndex.set(index);
            }
        }
    };
    // console.log("moduleIndex.get()",moduleIndex.get());
    useEffect(() => {
        if (props.showSaveAsDraftBtn) {
            setDirty(agentSaveAsDraftState.showConfirmPopUp.get());
        }
        else {
            setDirty(false);
        }
    }, [agentSaveAsDraftState, props.showSaveAsDraftBtn])

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (props.asAdmin) {
                    resetState(true);
                }
                if (props.data) {
                    const userData = props.data;
                    let eventJson = null;
                    state.firstName.set(userData.firstName);
                    state.lastName.set(userData.lastName);
                    state.dob.set(
                        Helper.IfDateIsDefault(userData.dob) ? null : userData.dob
                    );
                    state.email.set(userData.email);
                    state.contactNo.set(userData.contactNo ? userData.contactNo : '');
                    //state.sex.set(userData.sex ? userData.sex : '');
                    //state.vaccinated.set(userData.vaccinated);
                    state.mailingAddress.set(
                        userData.mailingAddress ? userData.mailingAddress : ''
                    );
                    state.certifiedagentContactName.set(
                        userData.alternateContactName
                            ? userData.alternateContactName
                            : ''
                    );
                    state.certifiedagentContactNo.set(
                        userData.alternateContactNo ? userData.alternateContactNo : ''
                    );
                    state.certifiedagentContactEmail.set(
                        userData.alternateContactEmail
                            ? userData.alternateContactEmail
                            : ''
                    );
                    state.CertifiedAgentPicUrl.set(
                        userData.certifiedAgentPicUrl
                            ? userData.certifiedAgentPicUrl
                            : ''
                    );
                    state.oldCertifiedAgentPicUrl.set(
                        userData.certifiedAgentPicUrl
                            ? userData.certifiedAgentPicUrl
                            : ''
                    );
                    state.familymemberContactName.set(
                        userData.familyMemberContactName ? userData.familyMemberContactName : ''
                    );
                    state.familymemberContactNo.set(
                        userData.familyMemberContactNo
                            ? userData.familyMemberContactNo
                            : ''
                    );
                    state.familymemberEmail.set(
                        userData.familyMemberContactEmail
                            ? userData.familyMemberContactEmail
                            : ''
                    );
                    state.familymemberPicUrl.set(
                        userData.familyMemberPicUrl
                            ? userData.familyMemberPicUrl
                            : ''
                    );
                    state.oldFamilymemberPicUrl.set(
                        userData.familyMemberPicUrl
                            ? userData.familyMemberPicUrl
                            : ''
                    );
                    state.personalphysicianContactName.set(
                        userData.personalPhysicianContactName ? userData.personalPhysicianContactName : ''
                    );
                    state.personalphysicianEmail.set(
                        userData.personalPhysicianContactEmail
                            ? userData.personalPhysicianContactEmail
                            : ''
                    );
                    state.personalphysicianContactNo.set(
                        userData.personalPhysicianContactNo ? userData.personalPhysicianContactNo : ''
                    );
                    state.athleticTrainerName.set(
                        userData.athleticTrainerName ? userData.athleticTrainerName : ''
                    );
                    state.athleticTrainerCell.set(
                        userData.athleticTrainerCell ? userData.athleticTrainerCell : ''
                    );
                    state.athleticTrainerEmail.set(
                        userData.athleticTrainerEmail
                            ? userData.athleticTrainerEmail
                            : ''
                    );
                    state.dietRestrictions.set(
                        userData.dietRestrictions ? userData.dietRestrictions : ''
                    );
                    state.reason.set(userData.reason ? userData.reason : '');
                    state.agentProDayParticipant.set((userData.agentProDayParticipant === undefined || userData.agentProDayParticipant === null) ? "" : userData.agentProDayParticipant);
                    state.attendingDraftNBA.set((userData.attendingDraftNBA === undefined || userData.attendingDraftNBA === null) ? "" : userData.attendingDraftNBA  );
                    state.isFamilyMemberAttend.set(userData.isFamilyMemberAttend ? userData.isFamilyMemberAttend : "");
                    state.isCertifiedAgentAttend.set(userData.isCertifiedAgentAttend ? userData.isCertifiedAgentAttend : "");
                    state.participateInFiveOnFive.set(userData.isActivity1)
                    state.defenceDrills.set(userData.isActivity2)
                    state.requestStatus.set(userData.requestStatus)
                    state.athleticDirectorName.set(userData.athleticDirectorName
                        ? userData.athleticDirectorName
                        : '')
                    state.athleticDirectorEmail.set(userData.athleticDirectorEmail ? userData.athleticDirectorEmail : "")
                    state.basketballAdminName.set(userData.basketBallAdminName ? userData.basketBallAdminName : "")
                    state.basketballAdminEmail.set(userData.basketBallAdminEmail ? userData.basketBallAdminEmail : "")
                    state.basketballAdminContactNo.set(userData.basketBallAdminContactNo ? userData.basketBallAdminContactNo : "")
                    state.agentRoomRequestAccepted.set((userData.agentRoomRequestAccepted !== null && userData.agentRoomRequestAccepted !== "") ? userData.agentRoomRequestAccepted : "")

                     cities.forEach((row) => {
                        row['select'] = false;
                    });
                    let index = cities.findIndex((x) => x.label == userData.proCity);
                    if (index > -1) {
                        cities[index]['select'] = true;
                        cities
                            .filter((x) => x.select === true)
                            .map((item) => {
                                setCityID(item);
                            });
                    }
                    state.registrationID.set(
                        userData.registrationID ? userData.registrationID : 0
                    );
                    state.createdDate.set(userData.createdDate);
                    state.addedFor.set(userData.addedFor);
                    if (userData.addedFor && props.participantList) {
                        const index = props.participantList.findIndex(
                            (user) => user.userID == userData.addedFor
                        );
                        if (index > -1) {
                            setParticipant(props.participantList[index]);
                            eventJson = await getEventJSON(props.participantList[index]);
                        }
                    } else {
                        eventJson = await getEventJSON(userData);
                    }
                    const eventForm = userData.eventForm
                        ? JSON.parse(userData.eventForm)
                        : eventJson;
                    if (eventForm) {
                        state.eventForm.set(eventForm);
                        // console.log(eventForm);
                    }
                }
            } catch (error) {
                console.error('Error in useEffect:', error);
            }
        };
        fetchData();
    }, [props.data]);

    const getParticipantList = () => {
        const gEventInfo = Helper.getStorage('eventInfo');
        ApiHelper.get(
            APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(gEventInfo.eventID)
        ).then((res) => {
            if (res.data.rows) {
                const participants = res.data.rows.filter(
                    (participant) =>
                        AppConstants.EVENT_ROLES_VALUES.indexOf(
                            participant.roleName
                        ) == -1
                );
                setParticipantList(participants);
            }
        });
    };
    const isValidForm = () => {
        const selectedState = state.get();
        // console.log("selectedState",selectedState);
        let isValid = true;
        let exist =
            state.eventForm.get() !== null &&
            state.eventForm
                .get()
                .FormFields.find(
                    (x) =>
                        x.FieldValue === true
                );
        if (state.eventForm.get() !== null && exist === undefined) {
            setSnackBarProps({
                openSnack: true,
                variant: 'error',
                message: 'Please select an attendance option',
            });
            isValid = false;
        }
        if (
            state.eventForm.get() !== null &&
            state.eventForm
                .get()
                .FormFields.find(
                    (x) => x.FieldValue === true && x.FieldName === 'NotAttend'
                )
        ) {
            if (
                selectedState.reason === null ||
                reasonErr.length > 0 ||
                selectedState.reason?.trim()?.length == 0
            ) {
                setReasonErr("Please Enter Reason");
                isValid = false;
            }
        } else {
            if(state.eventForm.get() !== null){
                if (state.participateInFiveOnFive.get() === "" || state.participateInFiveOnFive.get() == undefined) {
                    setParticipateInFiveOnFiveErr("please select one option")
                    isValid = false;
                }
                if (state.defenceDrills.get() === "" || state.defenceDrills.get() == undefined) {
                    setDefenceDrillsErr("please select one option")
                    isValid = false;
                }
            } 
        } 
        // let exist =
        //     state.eventForm.get() !== null &&
        //     state.eventForm
        //         .get()
        //         .FormFields.find(
        //             (x) =>
        //                 x.FieldValue === true && x.FieldName !== 'NotAttend'
        //         );
        if (
            selectedState.firstName === null ||
            firstNameErr.length > 0 ||
            selectedState.firstName?.trim()?.length == 0
        ) {
            setFirstNameErr('Please Enter First Name');
            isValid = false;
        }

        if (
            selectedState.lastName === null ||
            lasttNameErr.length > 0 ||
            selectedState.lastName?.trim()?.length == 0
        ) {
            setLastNameErr('Please Enter Last Name');
            isValid = false;
        }

        if (
            selectedState.email === null ||
            emailErr.length > 0 ||
            selectedState.email?.trim()?.length == 0
        ) {
            setEmailErr('Please Enter Email');
            isValid = false;
        }
        if (
            selectedState.dob == null ||
            dobErr.length > 0 ||
            selectedState.dob?.length == 0
        ) {
            setDOBErr('Please Enter Date Of Birth');
            isValid = false;
        }

        if (
            selectedState.mailingAddress === null ||
            mailingError.length > 0 ||
            selectedState.mailingAddress?.trim()?.length == 0
        ) {
            setMailingError('Please Enter Mailing Address');
            isValid = false;
        }
        if (
            selectedState.contactNo === null ||
            phoneError.length > 0 ||
            selectedState.contactNo?.trim()?.length == 0
        ) {
            setPhoneError('Please Enter Contact Number');
            isValid = false;
        }
        if (!selectedState.isCertifiedAgentAttend) {
            if (
                // !exist &&
                (selectedState.certifiedagentContactName === null ||
                    altNameErr.length > 0 ||
                    selectedState.certifiedagentContactName?.trim()?.length == 0) ||
                    !Helper.onlyLettersAndSpacesWithHyphensAndDot(
                        selectedState.certifiedagentContactName
                    )
            ) {
                setAltNameErr('Please Enter Valid Certified Agent Name');
                isValid = false;
            }
            if (
                // !exist &&
                selectedState.certifiedagentContactName === null ||
                selectedState.certifiedagentContactName === '' ||
                altNameErr.length > 0 
            ) {
                setAltNameErr('Please Enter Certified Agent Name');
                isValid = false;
            }
            if (
                ((selectedState.certifiedagentContactNo === null || selectedState.certifiedagentContactNo === ""))
            ) {
                setAltPhoneError('Please Enter Certified Agent Number');
                isValid = false;
            }
            if (
                ((selectedState.certifiedagentContactEmail === null ||
                    altEmailErr.length > 0 ||
                    selectedState.certifiedagentContactEmail?.trim()?.length ==
                    0)) ||
                !Helper.validEmail(selectedState.certifiedagentContactEmail)
            ) {
                setAltEmailErr('Please Enter Certified Agent Email');
                isValid = false;
            }
            if (
                selectedState.athleticTrainerEmail !== null &&
                selectedState.athleticTrainerEmail !== '' &&
                !Helper.validEmail(selectedState.athleticTrainerEmail)
            ) {
                setAthEmailErr('Please Enter Valid Certified Agent Email');
                isValid = false;
            }
            // if (selectedState.CertifiedAgentPicUrl === "") {
            //     setSnackBarProps({
            //         openSnack: true,
            //         variant: 'error',
            //         message: 'Please select Certified Agent Picture',
            //     });
            //     isValid = false;
            // }
        } 
        if (
            ((selectedState.athleticTrainerName === null ||
                athNameErr.length > 0 ||
                selectedState.athleticTrainerName?.trim()?.length ==
                0)) ||
            !Helper.onlyLettersAndSpacesWithHyphensAndDot(
                selectedState.athleticTrainerName
            )
        ) {
            setAthNameErr('Please Enter Valid Athletic Trainer Name');
            isValid = false;
        }
        if (
            (selectedState.athleticTrainerCell == "" || selectedState.athleticTrainerCell == null ||
                athPhoneError.length > 0 ||
                selectedState.athleticTrainerCell?.trim()?.length == 0)
        ) {
            setAthPhoneError(
                'Please Enter Athletic Trainer Contact Number'
            );
            isValid = false;
        }
        if (
            (selectedState.athleticTrainerEmail === null ||
                athEmailErr.length > 0 ||
                selectedState.athleticTrainerEmail?.trim()?.length == 0)
        ) {
            setAthEmailErr('Please Enter Valid Athletic Trainer Email');
            isValid = false;
        }
        if (showAgentProParticipant && 
            (state.attendingDraftNBA.get() === "" || state.attendingDraftNBA.get() == undefined)
        ) {
            setSnackBarProps({
                openSnack: true,
                variant: 'error',
                message: 'Please select attending the NBA Draft',
            });
            setAttendingNBADraftErr(true)
            isValid = false;
        }
        if (showAgentProParticipant &&
            (state.agentProDayParticipant.get() === "" || state.agentProDayParticipant.get() == undefined)
        ) {
            setSnackBarProps({
                openSnack: true,
                variant: 'error',
                message: 'Please select Are you planning to participate in an agent Pro Day',
            });
            setAgentProdDayErr(true)
            isValid = false;
        }

        if (
            state.agentProDayParticipant.get() &&
            cities.length > 0 &&
            !cities.find((x) => x.select === true)
        ) {
            setSnackBarProps({
                openSnack: true,
                variant: 'error',
                message: 'Please select city',
            });
            isValid = false;
        }
        if (((selectedState.athleticDirectorName == "" || selectedState.athleticDirectorName == undefined) ||
            athleticDirectorNameErr.length > 0 ||
            selectedState.athleticDirectorName?.trim()?.length == 0)

        ) {
            setAthleticDirectorNameErr('Please Enter Athletic Director Name');
            isValid = false;
        }

        if (((selectedState.athleticDirectorEmail === "" || selectedState.athleticDirectorEmail === undefined) ||
            athleticDirectorEmailErr.length > 0 ||
            selectedState.athleticDirectorEmail?.trim()?.length == 0)) {
            setAthleticDirectorEmailErr('Please Enter Athletic Director Email');
            isValid = false
        }

        if (((selectedState.basketballAdminName === "" || selectedState.basketballAdminName === undefined) ||
            basketballAdminNameErr.length > 0 ||
            selectedState.basketballAdminName?.trim()?.length == 0)) {
            setBasketballAdminNameErr('Please Enter Basketball Admin Name');
            isValid = false
        }

        if (((selectedState.basketballAdminEmail === "" || selectedState.basketballAdminName === undefined) ||
            basketballAdminEmailErr.length > 0 ||
            selectedState.basketballAdminEmail?.trim()?.length == 0)) {
            setBasketballAdminEmailErr('Please Enter Basketball Admin Email');
            isValid = false
        }
        if (
            (selectedState.basketballAdminContactNo == "" || selectedState.basketballAdminContactNo == null ||
                basketballAdminContactNoError.length > 0 ||
                selectedState.basketballAdminContactNo?.trim()?.length == 0)
        ) {
            setBasketballAdminContactNoError('Please Enter Basketball Admin Number');
            isValid = false;
        }
        if((selectedState.personalPhysicianContactEmail != "" || selectedState.personalPhysicianContactEmail != null) &&
        personalphysicianEmailError.length > 0){
            setpersonalphysicianEmailError('Please Enter valid Personal Physician Email');
            isValid = false; 
        }
        if((selectedState.personalPhysicianContactNo != "" || selectedState.personalPhysicianContactNo != null) && (
        personalphysicianContactNoError.length > 0)){
            setpersonalphysicianContactNoError('Please Enter valid Personal Physician Contact Number');
            isValid = false; 
        }  
        if ((eventInfo.eventID !== eliteConfigEventID && !state.isCertifiedAgentAttend.get()) && (state.agentRoomRequestAccepted.get() === "" || state.agentRoomRequestAccepted.get() == undefined)) {
            setAgentRoomRequestError('Please Select hotel room for your certified agent');
            isValid = false;
        }
        return isValid;
    }; 
    
    const handleAgentRoomConfirmation = () => {
        const gEventInfo = Helper.getStorage('eventInfo');
        const gAgentInfo = Helper.getSessionStorage('agentUser');
        const agentConnection = Helper.getSessionStorage('agentConnections');
        let obj = {};
        obj.eventID = gEventInfo.eventID;
        obj.moduleID = 4;
        obj.userID = agentState.visible.value
                    ? agentState.user.get() && agentState.user.get().userID
                    : participant
                        ? participant.userID
                        : state.get().addedFor
                            ? state.get().addedFor
                            : userInfo.userID;
        obj.IsAgentRoomRequestAccepted = !state.isCertifiedAgentAttend.get() ? state.agentRoomRequestAccepted.get() : false;
        obj.createdBy = createdByUser.userID;
        ApiHelper.post(APIURLConstants.INS_UPD_HOTEL_AGENT_REQUEST, obj)
            .then((res) => {
                setOpenBackDrop(false);
                if (res.data) {                    
                    return true
                }
            })
            .catch((error) => {
                let message = '';
                if (error.response && error.response.status === 401) {
                    message = 'Access denied';
                } else {
                    message = 'Error while updating request';
                }
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'error',
                    message: message,
                });
            });
    }
    const handleClick = (event) => {
        setDisableBtn(true);
        resetSaveAsDraftState();
        setDisableDraftBtn(true);
        event.preventDefault();
        const selectedState = state.get();
        let selectedValues =
            selectedState.eventForm && selectedState.eventForm !== null
                ? selectedState.eventForm?.FormFields?.filter(
                    (x) => x.FieldValue
                )
                    .map((y) => y.FieldName)
                    .join(', ')
                : '';
        // console.log("isValidForm()",isValidForm());
        if (!isValidForm()) {
            setDisableBtn(false);
            setDisableDraftBtn(false);
            return false;
        } else if (
            (selectedState.eventForm === null && selectedValues === '') ||
            (selectedState.eventForm !== null && selectedValues !== '')
            // selectedState.checkBox1 === true ||
            // selectedState.checkBox2 == true ||
            // selectedState.checkBox3 === true ||
            // selectedState.checkBox4 === true
        ) {
            setDisableBtn(true);
            setDisableDraftBtn(true);
            props.loading.set(true)
            const eventInfo = Helper.getStorage('eventInfo');
            const userInfo = Helper.getStorage('userInfo');
            const gAgentInfo = Helper.getStorage('agentUser');
            const agentConnection = Helper.getStorage('agentConnections');
            // const checkBoxData = {
            //     checkBox1: selectedState.checkBox1,
            //     checkBox2: selectedState.checkBox2,
            //     checkBox3: selectedState.checkBox3,
            //     checkBox4: selectedState.checkBox4,
            // };
            // console.log("checkboxObj",selectedState.eventForm);
            let updCombineRegistrationUsers = [];
            let checkboxObj =
                selectedState.eventForm !== null
                    ? JSON.stringify(selectedState.eventForm)
                    : null;
            if (checkboxObj !== null) {
                if (
                    selectedState.eventForm.FormFields &&
                    selectedState.eventForm.FormFields.length > 0
                ) {
                    selectedState.eventForm.FormFields.map((val, index) => {
                        if (val.FieldValue === true) {
                            if (index === 0) {
                                updCombineRegistrationUsers.push({
                                    eventID: eventInfo.eventID,
                                    userID:
                                        agentConnection && gAgentInfo
                                            ? gAgentInfo.userID
                                            : participant
                                                ? participant.userID
                                                : selectedState.addedFor
                                                    ? selectedState.addedFor
                                                    : userInfo.userID,
                                    combineRegistrationUserID: 0,
                                    event1: 1,
                                    event2: 1,
                                    event3: 1,
                                    event4: 1,
                                    event5: 0,
                                    modifyBy: agentState.visible.value
                                        ? agentInfo.userID
                                        : userInfo.userID,
                                });
                            } else if (index === 1) {
                                updCombineRegistrationUsers.push({
                                    eventID: eventInfo.eventID,
                                    userID:
                                        agentConnection && gAgentInfo
                                            ? gAgentInfo.userID
                                            : participant
                                                ? participant.userID
                                                : selectedState.addedFor
                                                    ? selectedState.addedFor
                                                    : userInfo.userID,
                                    combineRegistrationUserID: 0,
                                    event1: 1,
                                    event2: 0,
                                    event3: 1,
                                    event4: 1,
                                    event5: 0,
                                    modifyBy: agentState.visible.value
                                        ? agentInfo.userID
                                        : userInfo.userID,
                                });
                            } else if (index === 2) {
                                updCombineRegistrationUsers.push({
                                    eventID: eventInfo.eventID,
                                    userID:
                                        agentConnection && gAgentInfo
                                            ? gAgentInfo.userID
                                            : participant
                                                ? participant.userID
                                                : selectedState.addedFor
                                                    ? selectedState.addedFor
                                                    : userInfo.userID,
                                    combineRegistrationUserID: 0,
                                    event1: 1,
                                    event2: 0,
                                    event3: 0,
                                    event4: 1,
                                    event5: 0,
                                    modifyBy: agentState.visible.value
                                        ? agentInfo.userID
                                        : userInfo.userID,
                                });
                            } else if (index === 3) {
                                updCombineRegistrationUsers.push({
                                    eventID: eventInfo.eventID,
                                    userID:
                                        agentConnection && gAgentInfo
                                            ? gAgentInfo.userID
                                            : participant
                                                ? participant.userID
                                                : selectedState.addedFor
                                                    ? selectedState.addedFor
                                                    : userInfo.userID,
                                    combineRegistrationUserID: 0,
                                    event1: 0,
                                    event2: 0,
                                    event3: 0,
                                    event4: 0,
                                    event5: 0,
                                    modifyBy: agentState.visible.value
                                        ? agentInfo.userID
                                        : userInfo.userID,
                                });
                            }
                        }
                    });
                }
            }
            const documentData = new FormData();
            documentData.append('registrationID', selectedState.registrationID);
            documentData.append('eventID', eventInfo.eventID);
            documentData.append('firstName', selectedState.firstName);
            documentData.append('lastName', selectedState.lastName);
            documentData.append('dob', Helper.FormatDateOnly(selectedState.dob) == ''
                ? null
                : Helper.FormatDateOnly(selectedState.dob));
            documentData.append('contactNo', selectedState.contactNo);
            documentData.append('email', selectedState.email);
            documentData.append('mailingAddress', selectedState.mailingAddress);
            documentData.append('alternateContactName', selectedState.certifiedagentContactName);
            documentData.append('alternateContactNo', selectedState.certifiedagentContactNo == "+1" ? "" : selectedState.certifiedagentContactNo ? selectedState.certifiedagentContactNo : "");
            documentData.append('alternateContactEmail', selectedState.certifiedagentContactEmail ? selectedState.certifiedagentContactEmail : "");
            documentData.append('athleticTrainerName', selectedState.athleticTrainerName ? selectedState.athleticTrainerName : "");
            documentData.append('athleticTrainerEmail', selectedState.athleticTrainerEmail ? selectedState.athleticTrainerEmail : "");
            documentData.append('athleticTrainerCell', selectedState.athleticTrainerCell == "+1" ? "" : selectedState.athleticTrainerCell ? selectedState.athleticTrainerCell : "");
            documentData.append('dietRestrictions', selectedState.dietRestrictions);
            documentData.append('reason', selectedState.reason);
            documentData.append('agentProDayParticipant', (selectedState.agentProDayParticipant != "" || selectedState.agentProDayParticipant != undefined) ? selectedState.agentProDayParticipant : "");
            documentData.append('attendingDraftNBA', (selectedState.attendingDraftNBA != "" || selectedState.attendingDraftNBA != undefined) ? selectedState.attendingDraftNBA : "");
            documentData.append('eventForm', checkboxObj);
            documentData.append('addedFor', agentState.visible.value
                ? agentState.user.get() && agentState.user.get().userID
                : participant
                    ? participant.userID
                    : selectedState.addedFor
                        ? selectedState.addedFor
                        : userInfo.userID);
            documentData.append('createdBy',  userInfo.userID);
            documentData.append('createdDate', props.data
                ? selectedState.createdDate
                : new Date());
            documentData.append('modifiedDate', selectedState.registrationID > 0 ? new Date() : null);
            documentData.append('proCityID', selectedState.agentProDayParticipant && cityID
                ? cityID.key
                : 0);
            documentData.append('isCertifiedAgentAttend', selectedState.isCertifiedAgentAttend ? selectedState.isCertifiedAgentAttend : false);
            documentData.append('isFamilyMemberAttend', selectedState.isFamilyMemberAttend ? selectedState.isFamilyMemberAttend : false);
            documentData.append('familyMemberContactName', selectedState.familymemberContactName ? selectedState.familymemberContactName : "");
            documentData.append('familyMemberContactEmail', selectedState.familymemberEmail ? selectedState.familymemberEmail : "");
            documentData.append('familyMemberContactNo', selectedState.familymemberContactNo ? selectedState.familymemberContactNo == "+1" ? "" : selectedState.familymemberContactNo : "");
            documentData.append('personalPhysicianContactName', selectedState.personalphysicianContactName ? selectedState.personalphysicianContactName : "");
            documentData.append('personalPhysicianContactEmail', selectedState.personalphysicianEmail ? selectedState.personalphysicianEmail : "");
            documentData.append('personalPhysicianContactNo', selectedState.personalphysicianContactNo ? selectedState.personalphysicianContactNo == "+1" ? "" : selectedState.personalphysicianContactNo : "");


            documentData.append('familyMemberPicUrl', selectedState.familymemberPicUrl && selectedState.familymemberPicUrl != undefined ? selectedState.familymemberPicUrl.name : selectedState.oldFamilymemberPicUrl ? selectedState.oldFamilymemberPicUrl.name : "");
            documentData.append('OldFamilyMemberPicUrl', selectedState.oldFamilymemberPicUrl);

            documentData.append('certifiedAgentPicUrl', selectedState.CertifiedAgentPicUrl && selectedState.CertifiedAgentPicUrl ? selectedState.CertifiedAgentPicUrl.name : selectedState.OldCertifiedAgentPicUrl ? selectedState.OldCertifiedAgentPicUrl.name : "");
            documentData.append('OldCertifiedAgentPicUrl', selectedState.oldCertifiedAgentPicUrl);
            documentData.append('FamilyMemberPic', state.familymemberPicUrl.attach(Downgraded).get());
            documentData.append('CertifiedAgentPic', state.CertifiedAgentPicUrl.attach(Downgraded).get());
            documentData.append('updCombineRegistrationUsers', JSON.stringify(updCombineRegistrationUsers));

            documentData.append('IsActivity1', state.participateInFiveOnFive.attach(Downgraded).get() == undefined ? "" : state.participateInFiveOnFive.attach(Downgraded).get());
            documentData.append('IsActivity2', state.defenceDrills.attach(Downgraded).get() == undefined ? "" : state.defenceDrills.attach(Downgraded).get());
            documentData.append('AthleticDirectorName', state.athleticDirectorName.attach(Downgraded).get());
            documentData.append('AthleticDirectorEmail', state.athleticDirectorEmail.attach(Downgraded).get());
            documentData.append('BasketBallAdminName', state.basketballAdminName.attach(Downgraded).get());
            documentData.append('BasketBallAdminEmail', state.basketballAdminEmail.attach(Downgraded).get());
            documentData.append('BasketBallAdminContactNo', state.basketballAdminContactNo.attach(Downgraded).get());
            documentData.append('agentRoomRequestAccepted', state.agentRoomRequestAccepted.attach(Downgraded).get() ?? "");


            // console.log("Obj",documentData);
            ApiHelper.post(APIURLConstants.POST_REGISTRATION_INFO, documentData)
                .then(async (res) => {
                    // console.log("into res");
                    
                    setDisableBtn(false);
                    if (res.status === 200) {
                        // console.log("into res.data"); 
                        eventInfo.eventID !== eliteConfigEventID && handleAgentRoomConfirmation() 
                        setSnackBarProps({
                            ...snackBarProps,
                            openSnack: true,
                            variant: 'success',
                            message: state.registrationID.get() > 0
                            ? 'Form updated successfully' : 'Form submitted successfully',
                        });
                        // let selectedOption =
                        //     selectedState.eventForm !== null
                        //         ? selectedState.eventForm.FormFields.find(
                        //             (x) => x.FieldValue === true
                        //         )?.FieldName
                        //         : '';
                        // let isPublished = participantList.filter(
                        //     (x) =>
                        //         x.isPublished === true &&
                        //         x.userID === Obj.addedFor
                        // );
                        // if (isPublished.length > 0) {
                        //     SETEmailNotification({
                        //         ...Obj,
                        //         eventForm: selectedOption,
                        //         dob: Helper.FormatDate(Obj.dob),
                        //         proCity:
                        //             selectedState.agentProDayParticipant &&
                        //                 cityID
                        //                 ? cityID.label
                        //                 : '',
                        //     });
                        // }
                        updateModuleState();
                        props.loading.set(false)
                        setTimeout(() => {
                            if (props.asAdmin) {
                                resetState(true);
                                props.history.push({
                                    pathname: generatePath(
                                        RouteConstants.EVENT_REGISTRATION_LIST,
                                        { eventID: eventInfo.eventID }
                                    ),
                                });
                            } else {
                                props.history.push(
                                    generatePath(RouteConstants.EVENT_DETAIL, {
                                        eventID: eventInfo.eventID,
                                    })
                                );
                                props.getAllRegistrationInfo()
                            }
                        }, 1000);
                    }
                })
                .catch((error) => {
                    props.loading.set(false)
                    setDisableBtn(false);
                    console.log('error : ', error);
                    let message = '';
                    if (error.response && error.response.status === 401) {
                        message = 'Access denied';
                    } else {
                        message = 'Error while Adding Registration';
                    }
                    setSnackBarProps({
                        openSnack: true,
                        variant: 'error',
                        message: message,
                    });
                    // props.handleClose();
                    // props.getParticipants();
                });
        } else if (selectedState.eventForm !== null && selectedValues === '') {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Please select atleast one draft combine',
            });
            setDisableBtn(false);
            return;
        }
    };
    const handleBlur = (dateval) => {
        //let dateval = state.dob.attach(Downgraded).get();
        // let dateval = event.target.value;
        if (
            state.eventForm.get() !== null &&
            state.eventForm
                .get()
                .FormFields.find(
                    (x) => x.FieldValue === true && x.FieldName !== 'NotAttend'
                )
        ) {
            if (dateval == '') {
                setDOBErr('');
            } else if (!moment(dateval).isValid()) {
                setDOBErr('Please enter valid date');
            } else if (dateval.indexOf('/') > -1) {
                let chkdate = dateval.split('/');
                if (chkdate[2] && chkdate[2] < 1900) {
                    setDOBErr('Please enter date > 1900');
                } else {
                    setDOBErr('');
                }
            } else {
                setDOBErr('');
            }
        } else {
            setDOBErr('');
        }
    };

    const checkValidPhone = (val) => {
        state.contactNo.set(val);
        handleDisableBtn();
        const phone = state.contactNo.get() ?? '';
        //let regex = /^\s*(?:\+?(\d{1,3}))?([-. (]*(\d{3})[-. )]*)?((\d{3})[-. ]*(\d{9,9})(?:[-.x ]*(\d+))?)\s*$/gm;
        let regex = /^(\+?\d{1,3}[- ]?)?\d{11}$/;
        if (phone === '') {
            setPhoneError('Please Enter Agent Number');
            return false;
        } else if (!regex.test(phone)) {
            setPhoneError('Please Enter Valid Contact Number');
        } else {
            setPhoneError('');
            return true;
        }
    };
    const checkAltValidPhone = (val) => {
        state.certifiedagentContactNo.set(val);
        handleDisableBtn();
        const phone = state.certifiedagentContactNo.get() ?? '';
        // let regex = /^\s*(?:\+?(\d{1,3}))?([-. (]*(\d{3})[-. )]*)?((\d{3})[-. ]*(\d{9,9})(?:[-.x ]*(\d+))?)\s*$/gm;
        let regex = /^(\+?\d{1,3}[- ]?)?\d{11}$/;
        let exist =
            state.eventForm.get() !== null &&
            state.eventForm
                .get()
                .FormFields.find(
                    (x) => x.FieldValue === true && x.FieldName === 'NotAttend'
                );

        if (!exist && phone === '') {
            setAltPhoneError('Please Enter Agent Number');
        } else if (!exist && !regex.test(phone)) {
            setAltPhoneError('Please Enter Valid Number');
        } else {
            setAltPhoneError('');
        }
    }; 
    const checkAthValidPhone = (val) => {
        state.athleticTrainerCell.set(val);
        handleDisableBtn();
        const phone = state.athleticTrainerCell.get() ?? '';
        // let regex = /^\s*(?:\+?(\d{1,3}))?([-. (]*(\d{3})[-. )]*)?((\d{3})[-. ]*(\d{9,11})(?:[-.x ]*(\d+))?)\s*$/gm;
        let regex = /^(\+?\d{1,3}[- ]?)?\d{11}$/;
        let exist =
            state.eventForm.get() !== null &&
            state.eventForm
                .get()
                .FormFields.find(
                    (x) => x.FieldValue === true && x.FieldName === 'NotAttend'
                );
        if (!exist && phone === '') {
            setAthPhoneError('Please Enter Athletic Contact Number');
        } else if (!exist && !regex.test(phone)) {
            setAthPhoneError(
                'Please Enter Valid Athletic Trainer Contact Number'
            );
        } else {
            setAthPhoneError('');
        }
    };

    const checkMailingAddressValid = () => {
        const address = state.mailingAddress.get();
        if (address == null || address == '') {
            setMailingError('Please Enter Mailing Address');
        } else {
            setMailingError('');
        }
    };
    const validateFirstName = () => {
        let value = state.firstName.get().trim();
        if (value === '') {
            setFirstNameErr('Please Enter First Name');
            return false;
        }
        if (!Helper.onlyLettersAndSpacesWithHyphensAndDot(value)) {
            setFirstNameErr('Please Enter Valid First Name');
            return false;
        } else setFirstNameErr('');
        return true;
    }; 
    const onChangeCertifiedAgentAttend = (e) => {
        state.isCertifiedAgentAttend.set(
            e.target.checked
        );
        if (e.target.checked) {
            setAltNameErr('')
            setAltEmailErr('')
            setAltPhoneError('')
            state.agentRoomRequestAccepted.set('');
            setAgentRoomRequestError('')
        } else {
            validateAltName();
            ValidateAlternateEmail();
            checkAltValidPhone(state.certifiedagentContactNo.get())
        }
        handleDisableBtn();
    }

    const validateAltName = () => {
        let value = state.certifiedagentContactName.get().trim();
        let exist =
            state.eventForm.get() !== null &&
            state.eventForm
                .get()
                .FormFields.find(
                    (x) => x.FieldValue === true && x.FieldName === 'NotAttend'
                );
        if (!exist && value === '') {
            setAltNameErr('Please Enter Agent Contact Name');
        } else if (!exist && !Helper.onlyLettersAndSpacesWithHyphensAndDot(value)) {
            setAltNameErr('Please Enter Valid Agent Contact Name');
        } else {
            setAltNameErr('');
        }
    };


    const validatepersonalphysician = () => {
        if (
            state.personalphysicianContactName.get().trim() &&
            !Helper.onlyLettersAndSpacesWithHyphensAndDot(
                state.personalphysicianContactName.get()
            )
        ) {
            setpersonalphysicianNoError('Please Enter Valid Personal Physician Name');
            return false;
        }
        else setpersonalphysicianNoError('');
        return true;
    }
    const validatePersonalPhysicianContactEmail = () =>{
        const value = state.personalphysicianEmail.get() ?? ''; 
        if(value === ''){
            setpersonalphysicianEmailError('');
        }else if (!Helper.validEmail(value)) {
            setpersonalphysicianEmailError('Please Enter valid Personal Physician Email');
        } else {
            setpersonalphysicianEmailError('');
        }
    }
    const validatePersonalPhysicianContactNo = () => {
        handleDisableBtn();
        const phone = state.personalphysicianContactNo.get() ?? '';
        // let regex = /^\s*(?:\+?(\d{1,3}))?([-. (]*(\d{3})[-. )]*)?((\d{3})[-. ]*(\d{9,11})(?:[-.x ]*(\d+))?)\s*$/gm;
        let regex = /^(\+?\d{1,3}[- ]?)?\d{11}$/;
        console.log("phone",phone);
        if (phone === '+1' || phone === '1') {
            setpersonalphysicianContactNoError('');
        } else if (!regex.test(phone)) {
            setpersonalphysicianContactNoError(
                'Please Enter Valid Person Physician Contact Number'
            );
        } else {
            setpersonalphysicianContactNoError('');
        }
    }

    const validateAthName = () => {
        let value = state.athleticTrainerName.get().trim();
        let exist =
            state.eventForm.get() !== null &&
            state.eventForm
                .get()
                .FormFields.find(
                    (x) => x.FieldValue === true && x.FieldName === 'NotAttend'
                );
        if (!exist && value === '') {
            setAthNameErr('Please Enter Athletic Trainer Name');
        } else if (!exist && !Helper.onlyLettersAndSpacesWithHyphensAndDot(value)) {
            setAthNameErr('Please Enter Valid Athletic Trainer Name');
        } else {
            setAthNameErr('');
        }
    };

    const validatelastName = () => {
        let value = state.lastName.get().trim();
        if (value === '') {
            setLastNameErr('Please Enter Last Name');
            return false;
        }
        if (!Helper.onlyLettersAndSpacesWithHyphensAndDot(value)) {
            setLastNameErr('Please Enter Valid Last Name');
            return false;
        } else {
            setLastNameErr('');
            return true;
        }
    };

    function ValidateEmail() {
        const value = state.email.get();
        //state.email.set(value);
        if (value == '') {
            setEmailErr('Please Enter Participant Email');
        } else if (!Helper.validEmail(value)) {
            setEmailErr('Please Enter valid Participant Email');
        } else {
            setEmailErr('');
        }
    }  
    function ValidateAlternateEmail() {
        const value = state.certifiedagentContactEmail.get() ?? '';
        let exist =
            state.eventForm.get() !== null &&
            state.eventForm
                .get()
                .FormFields.find(
                    (x) => x.FieldValue === true && x.FieldName === 'NotAttend'
                );
        if (!exist && value === '') {
            setAltEmailErr('Please Enter Agent Contact Email');
        } else if (!exist && !Helper.validEmail(value)) {
            setAltEmailErr('Please Enter valid Agent Contact Email');
        } else {
            setAltEmailErr('');
        }
    }
    function validateAthleticDirectorName() {
        let value = state.athleticDirectorName.get() ?? '';
        if (value === '') {
            setAthleticDirectorNameErr('Please Enter Athletic Director Name');
            return false;
        }
        if (!Helper.onlyLettersAndSpacesWithHyphensAndDot(value)) {
            setAthleticDirectorNameErr('Please Enter Valid Athletic Director Name');
            return false;
        } else {
            setAthleticDirectorNameErr('');
            return true;
        }
    }
    function ValidateAthleticDirectorEmail() {
        const value = state.athleticDirectorEmail.get() ?? '';
        if (value === '') {
            setAthleticDirectorEmailErr('Please Enter Athletic Director Email');
        } else if (!Helper.validEmail(value)) {
            setAthleticDirectorEmailErr('Please Enter valid Athletic Director Email');
        } else {
            setAthleticDirectorEmailErr('');
            return true
        }
    }
    function validateBasketballAdminName() {
        let value = state.basketballAdminName.get() ?? '';
        if (value === '') {
            setBasketballAdminNameErr('Please Enter Basketball Admin Name');
            return false;
        }
        if (!Helper.onlyLettersAndSpacesWithHyphensAndDot(value)) {
            setBasketballAdminNameErr('Please Enter Valid Basketball Admin Name');
            return false;
        } else {
            setBasketballAdminNameErr('');
            return true;
        }
    }
    function ValidateBasketballAdminEmail() {
        const value = state.basketballAdminEmail.get() ?? '';
        if (value === '') {
            setBasketballAdminEmailErr('Please Enter Basketball Admin Email');
        } else if (!Helper.validEmail(value)) {
            setBasketballAdminEmailErr('Please Enter valid Basketball Admin Email');
        } else {
            setBasketballAdminEmailErr('');
        }
    }

    const checkBasketballAdminValidPhone = (val) => {
        state.basketballAdminContactNo.set(val);
        handleDisableBtn();
        const phone = state.basketballAdminContactNo.get() ?? '';

        let regex = /^(\+?\d{1,3}[- ]?)?\d{11}$/;

        if (phone === '') {
            setBasketballAdminContactNoError('Please Enter Basketball Admin Number');
        } else if (!regex.test(phone)) {
            setBasketballAdminContactNoError('Please Enter Basketball Admin Valid Number');
        } else {
            setBasketballAdminContactNoError('');
        }
    };
    function ValidateAthleticEmail() {
        const value = state.athleticTrainerEmail.get() ?? '';
        let exist =
            state.eventForm.get() !== null &&
            state.eventForm
                .get()
                .FormFields.find(
                    (x) => x.FieldValue === true && x.FieldName === 'NotAttend'
                );

        if (!exist && !Helper.validEmail(value)) {
            setAthEmailErr('Please Enter valid Athletic Trainer Email');
        } else {
            setAthEmailErr('');
        }
    }
    function validateReason() {
        const value = state.reason.get();
        if (
            state.eventForm.get() !== null &&
            state.eventForm
                .get()
                .FormFields.find(
                    (x) => x.FieldValue === true && x.FieldName === 'NotAttend'
                )
        ) {
            //    if(isReason) {
            if (value !== '') {
                setReasonErr('');
            } else if (value == '') {
                setReasonErr('Please Enter Reason');
            }
        } else {
            setReasonErr('');
        }
    }
    const handleCancelReq = () => {
        resetState(true);
        props.handleCancel();
    };
    const getEventJSON = async (participant) => {
        try {
            if (participant?.userTags && participant?.userTags !== null) {
                let commonTags = eventTags.filter(
                    (x) => participant.userTags.split(', ').indexOf(x.tagName) > -1
                );
                const res = await ApiHelper.post(
                    APIURLConstants.GET_REGISTRATION_FORM(eventInfo.eventID),
                    commonTags.map((x) => x.tagID)
                );

                if (res.data !== null && res.data !== '') {
                    return JSON.parse(res.data.EventJSON);
                } else {
                    return () => null;
                }
            }
        } catch (err) {
            console.error(err);
            return () => null;
        }
    };
    const changeParticipant = async (participant) => {
        // eslint-disable-next-line no-debugger

        setParticipant(participant);
        setDisableBtn(false);
        let formJSON = await getEventJSON(participant);
        if (participant) {
            let name =
                participant.name &&
                    participant.name !== null &&
                    participant.name !== ''
                    ? participant.name.split(', ')
                    : [];
            state.firstName.set(name[1] ?? participant.firstName);
            state.lastName.set(name[0] ?? participant.lastName);
            state.dob.set(
                Helper.IfDateIsDefault(participant.dob) ? null : participant.dob
            );
            state.email.set(participant.email ?? '');
            state.contactNo.set(participant.contactNo ?? '');
            //state.sex.set('');
            //state.vaccinated.set(0);
            state.mailingAddress.set('');
            state.certifiedagentContactName.set('');
            state.certifiedagentContactNo.set('');
            state.certifiedagentContactEmail.set('');
            state.athleticTrainerName.set('');
            state.athleticTrainerCell.set('');
            state.athleticTrainerEmail.set('');
            state.dietRestrictions.set('');
            state.reason.set('');
            state.agentProDayParticipant.set("");
            state.attendingDraftNBA.set("");
            state.eventForm.set(formJSON ?? null);
            // state.checkBox1.set(false);
            // state.checkBox2.set(false);
            // state.checkBox3.set(false);
            // state.checkBox4.set(false);
            setFirstNameErr('');
            setLastNameErr('');
            setPhoneError('');
            setEmailErr('');
            setAltNameErr('');
            setpersonalphysicianNoError('');
            setAltEmailErr('');
            setAltPhoneError('');
            setAthNameErr('');
            setAthPhoneError('');
            setAthEmailErr('');
            setReasonErr('');
            setDOBErr('');
            setMailingError('');
        } else {
            resetState(false);
        }
        // state.registrationID.set(
        //     state.registrationID.get() > 0 ? state.registrationID.get() : 0
        // );
    };
    const cityChange = (event) => {
        cities.forEach((row) => {
            row['select'] = false;
        });
        let index = cities.findIndex((x) => x.label === event.target.value);
        cities[index]['select'] = event.target.checked;
        cities
            .filter((x) => x.select === true)
            .map((item) => {
                setCityID(item);
                state.cityID.set(item.key);
            });
        handleDisableBtn();
        setAgentProdDayErr(false)
    };
    const handleRadioChange = (event) => {
        let eventForm = state.eventForm.attach(Downgraded).get();
        eventForm.FormFields.forEach((row) => {
            row['FieldValue'] = false;
        });
        let index = eventForm.FormFields.findIndex(
            (x) => x.FieldName === event.target.value
        );
        eventForm.FormFields[index]['FieldValue'] = event.target.checked;
        if (index !== eventForm.FormFields.length - 1) {
            setShowfnfdnd(true)
            console.log("if part");
            // validateAltName();
            // ValidateAlternateEmail();
            // // validateAthName();
            // // ValidateAthleticEmail();
            // ValidateFamilyMemberName();
            // ValidateFamilyMemberEmail();
            // checkfamilyValidPhone()
            // if (state.certifiedagentContactNo.get() === '') {
            //     setAltPhoneError('please Enter Agent Number');
            // }
            // if (state.athleticTrainerCell.get() === '') {
            //     setAthPhoneError(
            //         'please Enter Athletic Trainer Contact Number'
            //     );
            // }
            // setMailingError('');
            // setDOBErr('');
            // setPhoneError(''); 
            state.reason.set('')
        } else {
            // console.log("else first option");
            
            state.participateInFiveOnFive.set('')
            state.defenceDrills.set('')
            setShowfnfdnd(false)
            // if (state.reason.get() === '') {
            //     setReasonErr('Please Enter The Reason');
            // } else {
            //     setReasonErr('');
            // }
            // setMailingError('');
            // setDOBErr('');
            // setPhoneError('');
            // setAltNameErr('');
            // setAltEmailErr('');
            // setAltPhoneError('');
            // setAthNameErr('');
            // setAthEmailErr('');
            // setAthPhoneError('');
            // setFamMemEmailErr('')
            // setFamMemNameErr('')
            // setFamMemPhoneError('')
        }
        state.eventForm.set(eventForm);
        handleDisableBtn();
    };

    // const SETEmailNotification = (ObjRequest) => {
    //     ApiHelper.post(
    //         APIURLConstants.POST_SET_REGISTRATION_EMAIL_NOTIFICATION,
    //         ObjRequest
    //     )
    //         .then((result) => {
    //             console.log(result.data);
    //         })
    //         .catch((err) => {
    //             console.log(err);
    //         });
    // };

    const handleCheckBoxChange = (event) => {
        let eventForm = state.eventForm.attach(Downgraded).get();
        let index = eventForm.FormFields.findIndex(
            (x) => x.FieldName === event.target.name
        );
        eventForm.FormFields[index]['FieldValue'] = event.target.checked;
        if (index !== eventForm.FormFields.length - 1) {
            validateAltName();
            ValidateAlternateEmail();
            // validateAthName();
            // ValidateAthleticEmail();
            if (state.certifiedagentContactNo.get() === '') {
                setAltPhoneError('please Enter Agent Number');
            }
            // if (state.athleticTrainerCell.get() === '') {
            //     setAltPhoneError(
            //         'please Enter Athletic Trainer Contact Number'
            //     );
            // }
        } else {
            if (state.reason.get() === '') {
                setReasonErr('Please Enter The Reason');
            } else {
                setReasonErr('');
            }
            setMailingError('');
            setDOBErr('');
            setPhoneError('');
            setAltNameErr('');
            setAltEmailErr('');
            setAltPhoneError('');
            setAthNameErr('');
            setAthEmailErr('');
            setAthPhoneError('');
        }

        state.eventForm.set(eventForm);
    };
    const handleDisableBtn = () => {
        if (state.addedFor.get() > 0) {
            let registerData = props.data;
            // console.log("registerData",registerData);
            let prevData = {
                firstName: registerData.firstName,
                lastName: registerData.lastName,
                email: registerData.email,
                dob: Helper.FormatDate(registerData.dob),
                contactNo: registerData.contactNo,
                mailingAddress: registerData.mailingAddress,
                agentProDayParticipant: registerData.agentProDayParticipant,
                attendingDraftNBA: registerData.attendingDraftNBA,

                isCertifiedAgentAttend: registerData.isCertifiedAgentAttend,
                isFamilyMemberAttend: registerData.isFamilyMemberAttend,

                certifiedagentContactName: registerData.alternateContactName,
                certifiedagentContactNo: registerData.alternateContactNo,
                certifiedagentContactEmail: registerData.alternateContactEmail,

                familymemberContactName: registerData.familyMemberContactName,
                familymemberEmail: registerData.familyMemberContactEmail,
                familymemberContactNo: registerData.familyMemberContactNo,
                familyMemberPic: registerData.familyMemberPic,
                certifiedAgentPic: registerData.certifiedAgentPic,
                personalPhysicianContactEmail: registerData.personalPhysicianContactEmail,
                personalPhysicianContactName: registerData.personalPhysicianContactName,
                personalPhysicianContactNo: registerData.personalPhysicianContactNo,

                athleticTrainerName: registerData.athleticTrainerName,
                athleticTrainerCell: registerData.athleticTrainerCell,
                athleticTrainerEmail: registerData.athleticTrainerEmail,

                dietRestrictions: registerData.dietRestrictions,
                eventForm: registerData.eventForm,
                cityID: registerData.proCityID,
                agentRoomRequestAccepted:registerData.agentRoomRequestAccepted
            };
            let currentData = {
                firstName: state.get().firstName,
                lastName: state.get().lastName,
                email: state.get().email,
                dob: Helper.FormatDate(state.get().dob),
                contactNo: state.get().contactNo,
                mailingAddress: state.get().mailingAddress,
                agentProDayParticipant: state.get().agentProDayParticipant,
                attendingDraftNBA: state.get().attendingDraftNBA,
                isCertifiedAgentAttend: state.get().isCertifiedAgentAttend,
                isFamilyMemberAttend: state.get().isFamilyMemberAttend,

                certifiedagentContactName: state.get().certifiedagentContactName,
                certifiedagentContactNo: state.get().certifiedagentContactNo,
                certifiedagentContactEmail: state.get().certifiedagentContactEmail,

                familymemberContactName: state.get().familymemberContactName,
                familymemberEmail: state.get().familymemberEmail,
                familymemberContactNo: state.get().familymemberContactNo,

                personalPhysicianContactEmail: state.get().personalphysicianEmail,
                personalPhysicianContactName: state.get().personalPhysicianContactName,
                personalPhysicianContactNo: state.get().personalphysicianContactNo,

                athleticTrainerName: state.get().athleticTrainerName,
                athleticTrainerCell: state.get().athleticTrainerCell,
                athleticTrainerEmail: state.get().athleticTrainerEmail,

                familyMemberPic: state.get().familyMemberPic,
                certifiedAgentPic: state.get().certifiedAgentPic,

                dietRestrictions: state.get().dietRestrictions,
                eventForm: state.get().eventForm,
                cityID: state.get().cityID,
                agentRoomRequestAccepted:state.get().agentRoomRequestAccepted
            };
            if (JSON.stringify(prevData) === JSON.stringify(currentData)) {
                setDisableBtn(true);
            } else { 
                setDisableBtn(false);
            }
            if(state.requestStatus.get() !== '0'){
                setDisableDraftBtn(true);
            }else{
                setDisableDraftBtn(false);
            }
            
        } else {
            if (props.showSaveAsDraftBtn) {
                setAgentShowConfirmPopUp(true);
            }
            setDisableBtn(false);
            setDisableDraftBtn(false);
        }
    };

    const handleSaveAsDraft = async (event) => {
        let Obj = generatePostObjForSaveAsDraft();
        setSaveAsDraftLoader(true);
        setDisableDraftBtn(true);
        setDisableBtn(true);
        ApiHelper.post(APIURLConstants.POST_REGISTRATION_INFO, Obj)
            .then(async (res) => {
                setSaveAsDraftLoader(false);
                setAgentShowConfirmPopUp(false);
                setDisableBtn(false);
                if (res.status === 200) { 
                    eventInfo.eventID !== eliteConfigEventID && handleAgentRoomConfirmation() 
                    setSnackBarProps({
                        ...snackBarProps,
                        openSnack: true,
                        variant: 'success',
                        message: 'Form saved successfully',
                    });
                    props.getAllRegistrationInfo();
                    updateModuleState();
                }
            })
            .catch((error) => {
                setSaveAsDraftLoader(false);
                console.log(error);
            });
    }

    const handleSaveAsDraftOnPromptConfirm = () => {
        return new Promise((resolve, reject) => {
            let Obj = generatePostObjForSaveAsDraft();
            setOpenBackDrop(true);
            setDisableBtn(true);
            ApiHelper.post(APIURLConstants.POST_REGISTRATION_INFO, Obj)
                .then((res) => {
                    setOpenBackDrop(false);
                    if (res.status === 200) {  
                      eventInfo.eventID !== eliteConfigEventID && handleAgentRoomConfirmation() 
                        //below code is added to check to show save as draft pop up in case of agent dropdown
                        if (agentSaveAsDraftState.showConfirmPopUp.get() && agentSaveAsDraftState.agentUserInfo.get()) {
                            changeAgentUserHandler(agentSaveAsDraftState.agentUserInfo.get(), agentSaveAsDraftState.userEvents.get());
                        }
                        else {
                            props.getAllRegistrationInfo();
                            updateModuleState();
                            resetSaveAsDraftState();
                        }
                        resolve(true);
                    }
                })
                .catch((error) => {
                    setOpenBackDrop(false);
                    showErrorSnackBar(error);
                    resetSaveAsDraftState();
                    reject(false);
                });
        })
    }

    const generatePostObjForSaveAsDraft = () => {
        const selectedState = state.get();
        // console.log("selectedState",selectedState,typeof selectedState.agentProDayParticipant, (((selectedState.agentProDayParticipant != "") || (selectedState.agentProDayParticipant != 'undefined') || (selectedState.agentProDayParticipant != undefined)) ? "yes" : "no"));
        const gUserInfo = Helper.getStorage('userInfo');
        // console.log("gUserInfo",gUserInfo);
        const agentConnection = Helper.getSessionStorage('agentConnections');
        let Obj = {};
        let updCombineRegistrationUsers = [];
        let checkboxObj =
             selectedState.eventForm !== null
                 ? JSON.stringify(selectedState.eventForm)
                 : null;
         if (checkboxObj !== null) {
             if (
                 selectedState.eventForm.FormFields &&
                 selectedState.eventForm.FormFields.length > 0
             ) {
                 selectedState.eventForm.FormFields.map((val, index) => {
                     if (val.FieldValue === true) {
                         if (index === 0) {
                             updCombineRegistrationUsers.push({
                                 eventID: eventInfo.eventID,
                                 userID:
                                     agentConnection && agentInfo
                                         ? agentInfo.userID
                                         : participant
                                             ? participant.userID
                                             : selectedState.addedFor
                                                 ? selectedState.addedFor
                                                 : userInfo.userID,
                                 combineRegistrationUserID: 0,
                                 event1: 1,
                                 event2: 1,
                                 event3: 1,
                                 event4: 1,
                                 event5: 0,
                                 modifyBy: agentState.visible.value
                                     ? agentInfo.userID
                                     : userInfo.userID,
                             });
                         } else if (index === 1) {
                             updCombineRegistrationUsers.push({
                                 eventID: eventInfo.eventID,
                                 userID:
                                     agentConnection && agentInfo
                                         ? agentInfo.userID
                                         : participant
                                             ? participant.userID
                                             : selectedState.addedFor
                                                 ? selectedState.addedFor
                                                 : userInfo.userID,
                                 combineRegistrationUserID: 0,
                                 event1: 1,
                                 event2: 0,
                                 event3: 1,
                                 event4: 1,
                                 event5: 0,
                                 modifyBy: agentState.visible.value
                                     ? agentInfo.userID
                                     : userInfo.userID,
                             });
                         } else if (index === 2) {
                             updCombineRegistrationUsers.push({
                                 eventID: eventInfo.eventID,
                                 userID:
                                     agentConnection && agentInfo
                                         ? agentInfo.userID
                                         : participant
                                             ? participant.userID
                                             : selectedState.addedFor
                                                 ? selectedState.addedFor
                                                 : userInfo.userID,
                                 combineRegistrationUserID: 0,
                                 event1: 1,
                                 event2: 0,
                                 event3: 0,
                                 event4: 1,
                                 event5: 0,
                                 modifyBy: agentState.visible.value
                                     ? agentInfo.userID
                                     : userInfo.userID,
                             });
                         } else if (index === 3) {
                             updCombineRegistrationUsers.push({
                                 eventID: eventInfo.eventID,
                                 userID:
                                     agentConnection && agentInfo
                                         ? agentInfo.userID
                                         : participant
                                             ? participant.userID
                                             : selectedState.addedFor
                                                 ? selectedState.addedFor
                                                 : userInfo.userID,
                                 combineRegistrationUserID: 0,
                                 event1: 0,
                                 event2: 0,
                                 event3: 0,
                                 event4: 0,
                                 event5: 0,
                                 modifyBy: agentState.visible.value
                                     ? agentInfo.userID
                                     : userInfo.userID,
                             });
                         }
                     }
                 });
             }
         }
         const documentData = new FormData();
         documentData.append('registrationID', selectedState.registrationID);
         documentData.append('eventID', eventInfo.eventID);
         documentData.append('firstName', selectedState.firstName);
         documentData.append('lastName', selectedState.lastName);
         documentData.append('dob', Helper.FormatDateOnly(selectedState.dob) == ''
             ? null
             : Helper.FormatDateOnly(selectedState.dob));
         documentData.append('contactNo', selectedState.contactNo);
         documentData.append('email', selectedState.email);
         documentData.append('mailingAddress', selectedState.mailingAddress);
         documentData.append('alternateContactName', selectedState.certifiedagentContactName);
         documentData.append('alternateContactNo', selectedState.certifiedagentContactNo == "+1" ? "" : selectedState.certifiedagentContactNo ? selectedState.certifiedagentContactNo : "");
         documentData.append('alternateContactEmail', selectedState.certifiedagentContactEmail ? selectedState.certifiedagentContactEmail : "");
         documentData.append('athleticTrainerName', selectedState.athleticTrainerName ? selectedState.athleticTrainerName : "");
         documentData.append('athleticTrainerEmail', selectedState.athleticTrainerEmail ? selectedState.athleticTrainerEmail : "");
         documentData.append('athleticTrainerCell', selectedState.athleticTrainerCell == "+1" ? "" : selectedState.athleticTrainerCell ? selectedState.athleticTrainerCell : "");
         documentData.append('dietRestrictions', selectedState.dietRestrictions);
         documentData.append('reason', selectedState.reason);
         documentData.append('agentProDayParticipant', (selectedState.agentProDayParticipant != "" || selectedState.agentProDayParticipant != 'undefined' || selectedState.agentProDayParticipant != undefined) ? selectedState.agentProDayParticipant : "");
         documentData.append('attendingDraftNBA', (selectedState.attendingDraftNBA != "" || selectedState.attendingDraftNBA != undefined || selectedState.attendingDraftNBA != 'undefined') ? selectedState.attendingDraftNBA : "");
         documentData.append('eventForm', checkboxObj);
         documentData.append('addedFor', agentState.visible.value
             ? agentState.user.get() && agentState.user.get().userID
             : participant
                 ? participant.userID
                 : selectedState.addedFor
                     ? selectedState.addedFor
                     : userInfo.userID);
         documentData.append('createdBy', gUserInfo.userID);
         documentData.append('createdDate', props.data
             ? selectedState.createdDate
             : new Date());
         documentData.append('modifiedDate', selectedState.registrationID > 0 ? new Date() : null);
         documentData.append('proCityID', selectedState.agentProDayParticipant && cityID
             ? cityID.key
             : 0);
         documentData.append('isCertifiedAgentAttend', selectedState.isCertifiedAgentAttend ? selectedState.isCertifiedAgentAttend : false);
         documentData.append('isFamilyMemberAttend', selectedState.isFamilyMemberAttend ? selectedState.isFamilyMemberAttend : false);
         documentData.append('familyMemberContactName', selectedState.familymemberContactName ? selectedState.familymemberContactName : "");
         documentData.append('familyMemberContactEmail', selectedState.familymemberEmail ? selectedState.familymemberEmail : "");
         documentData.append('familyMemberContactNo', selectedState.familymemberContactNo ? selectedState.familymemberContactNo == "+1" ? "" : selectedState.familymemberContactNo : "");
         documentData.append('personalPhysicianContactName', selectedState.personalphysicianContactName ? selectedState.personalphysicianContactName : "");
         documentData.append('personalPhysicianContactEmail', selectedState.personalphysicianEmail ? selectedState.personalphysicianEmail : "");
         documentData.append('personalPhysicianContactNo', selectedState.personalphysicianContactNo ? selectedState.personalphysicianContactNo == "+1" ? "" : selectedState.personalphysicianContactNo : "");


         documentData.append('familyMemberPicUrl', selectedState.familymemberPicUrl && selectedState.familymemberPicUrl != undefined ? selectedState.familymemberPicUrl.name : selectedState.oldFamilymemberPicUrl ? selectedState.oldFamilymemberPicUrl.name : "");
         documentData.append('OldFamilyMemberPicUrl', selectedState.oldFamilymemberPicUrl);

         documentData.append('certifiedAgentPicUrl', selectedState.CertifiedAgentPicUrl && selectedState.CertifiedAgentPicUrl ? selectedState.CertifiedAgentPicUrl.name : selectedState.OldCertifiedAgentPicUrl ? selectedState.OldCertifiedAgentPicUrl.name : "");
         documentData.append('OldCertifiedAgentPicUrl', selectedState.oldCertifiedAgentPicUrl);
         documentData.append('FamilyMemberPic', state.familymemberPicUrl.attach(Downgraded).get());
         documentData.append('CertifiedAgentPic', state.CertifiedAgentPicUrl.attach(Downgraded).get());
         documentData.append('updCombineRegistrationUsers', JSON.stringify(updCombineRegistrationUsers));

         documentData.append('IsActivity1', state.participateInFiveOnFive.attach(Downgraded).get() == undefined ? "" : state.participateInFiveOnFive.attach(Downgraded).get());
         documentData.append('IsActivity2', state.defenceDrills.attach(Downgraded).get() == undefined ? "" : state.defenceDrills.attach(Downgraded).get());
         documentData.append('AthleticDirectorName', (state.athleticDirectorName.attach(Downgraded).get() != "" || state.athleticDirectorName.attach(Downgraded).get() != 'undefined' || state.athleticDirectorName.attach(Downgraded).get() != undefined) ? state.athleticDirectorName.attach(Downgraded).get() : "");
         documentData.append('AthleticDirectorEmail', (state.athleticDirectorEmail.attach(Downgraded).get() != "" || state.athleticDirectorEmail.attach(Downgraded).get() != 'undefined' || state.athleticDirectorEmail.attach(Downgraded).get() != undefined) ? state.athleticDirectorEmail.attach(Downgraded).get() : "");
         documentData.append('BasketBallAdminName', (state.basketballAdminName.attach(Downgraded).get() != "" || state.basketballAdminName.attach(Downgraded).get() != 'undefined' || state.basketballAdminName.attach(Downgraded).get() != undefined) ? state.basketballAdminName.attach(Downgraded).get() : "");
         documentData.append('BasketBallAdminEmail', (state.basketballAdminEmail.attach(Downgraded).get() != "" || state.basketballAdminEmail.attach(Downgraded).get() != 'undefined' || state.basketballAdminEmail.attach(Downgraded).get() != undefined) ? state.basketballAdminEmail.attach(Downgraded).get() : "");
         documentData.append('BasketBallAdminContactNo', (state.basketballAdminContactNo.attach(Downgraded).get() != "" || state.basketballAdminContactNo.attach(Downgraded).get() != 'undefined' || state.basketballAdminContactNo.attach(Downgraded).get() != undefined) ? state.basketballAdminContactNo.attach(Downgraded).get() : "");
         documentData.append('isDraft', true);
         documentData.append('agentRoomRequestAccepted', (state.agentRoomRequestAccepted.attach(Downgraded).get() ?? ""));


        // Obj = {
        //     registrationID: selectedState.registrationID,
        //     eventID: eventInfo.eventID,
        //     firstName: selectedState.firstName ? selectedState.firstName : '',
        //     lastName: selectedState.lastName ? selectedState.lastName : '',
        //     contactNo: selectedState.contactNo ? selectedState.contactNo : '',
        //     dob: Helper.FormatDateOnly(selectedState.dob) == '' ? null : Helper.FormatDateOnly(selectedState.dob),
        //     email: selectedState.email ? selectedState.email : '',
        //     mailingAddress: selectedState.mailingAddress ? selectedState.mailingAddress : '',             
        //     alternateContactName: selectedState.certifiedagentContactName ? selectedState.certifiedagentContactName : '',
        //     alternateContactNo: selectedState.certifiedagentContactNo ? selectedState.certifiedagentContactNo : '',
        //     alternateContactEmail: selectedState.certifiedagentContactEmail ? selectedState.certifiedagentContactEmail : '',
        //     updCombineRegistrationUsers: JSON.stringify(updCombineRegistrationUsers), 
        //     athleticTrainerName: selectedState.athleticTrainerName ? selectedState.athleticTrainerName : '',
        //     athleticTrainerCell: selectedState.athleticTrainerCell ? selectedState.athleticTrainerCell : '',
        //     athleticTrainerEmail: selectedState.athleticTrainerEmail ? selectedState.athleticTrainerEmail : '',

        //     reason: selectedState.reason ? selectedState.reason : '',

        //     agentProDayParticipant: (selectedState.agentProDayParticipant != "" || selectedState.agentProDayParticipant != undefined) ? selectedState.agentProDayParticipant : '',
        //     attendingDraftNBA: (selectedState.attendingDraftNBA != "" || selectedState.attendingDraftNBA != undefined) ? selectedState.attendingDraftNBA : '',
        //     proCityID: selectedState.agentProDayParticipant ? selectedState.agentProDayParticipant && cityID
        //     ? cityID.key
        //     : 0 : 0,
        //     eventForm: checkboxObj, 
        //     isCertifiedAgentAttend: selectedState.isCertifiedAgentAttend ? selectedState.isCertifiedAgentAttend : false,
        //     familyMemberContactName: selectedState.familyMemberContactName ? selectedState.familyMemberContactName : '',
        //     familyMemberContactEmail: selectedState.familyMemberContactEmail ? selectedState.familyMemberContactEmail : '',
        //     familyMemberContactNo: selectedState.familyMemberContactNo ? selectedState.familyMemberContactNo : '',
        //     personalPhysicianContactName: selectedState.personalPhysicianContactName ? selectedState.personalPhysicianContactName : '',
        //     personalPhysicianContactEmail: selectedState.personalPhysicianContactEmail ? selectedState.personalPhysicianContactEmail : '',
        //     personalPhysicianContactNo: selectedState.personalPhysicianContactNo ? selectedState.personalPhysicianContactNo : '',
        //     IsActivity1: (selectedState.participateInFiveOnFive != "" || selectedState.participateInFiveOnFive != undefined) ? selectedState.participateInFiveOnFive : '',
        //     IsActivity2: (selectedState.defenceDrills != "" || selectedState.defenceDrills != undefined) ? selectedState.defenceDrills : '',

        //     AthleticDirectorName: selectedState.athleticDirectorName ? selectedState.athleticDirectorName : '',
        //     AthleticDirectorEmail: selectedState.athleticDirectorEmail ? selectedState.athleticDirectorEmail : '',
        //     BasketBallAdminName: selectedState.BasketBallAdminName ? selectedState.BasketBallAdminName : '',

        //     BasketBallAdminName: selectedState.basketballAdminName ? selectedState.basketballAdminName : '',
        //     BasketBallAdminEmail: selectedState.basketballAdminEmail ? selectedState.basketballAdminEmail : '',
        //     BasketBallAdminContactNo: selectedState.basketballAdminContactNo ? selectedState.basketballAdminContactNo : '',

        //     addedFor: (Helper.isEventAdmin(agentInfo) || Helper.isAdminUser(agentInfo)) ? participant
        //         && participant.userID : agentConnection && agentInfo ? agentInfo.userID : participant ? participant.userID : selectedState.addedFor ? selectedState.addedFor : userInfo.userID,
        //     createdBy: userInfo.userID,
        //     comments: selectedState.comments,
        //     isDraft: true
        // };

        return documentData;
    }

    const handleCancelConfirmation = () => {
        //below code is added to check to show save as draft pop up in case of agent dropdown
        if (agentSaveAsDraftState.showConfirmPopUp.get() && agentSaveAsDraftState.agentUserInfo.get()) {
            changeAgentUserHandler(agentSaveAsDraftState.agentUserInfo.get(), agentSaveAsDraftState.userEvents.get());
        }

        return true;
    }

    const handleCenterifiedAgentImageUpload = () => {
        openUpload.set(true);
    };
    const handlefamilymemberImageUpload = () => {
        openFamilyMemberUpload.set(true);
    };
    const handleClose = () => {
        openUpload.set(false);
        handleDisableBtn()
    };
    const handleFamilyMemebrClose = () => {
        openFamilyMemberUpload.set(false);
        handleDisableBtn()
    };
    const changeProfilePhoto = (file) => {
        state.CertifiedAgentPicUrl.set(file);
        if (file.size >= 5000000) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Image File is too big',
            });
        } else {
            state.CertifiedAgentPicUrlsrc.set(URL.createObjectURL(file));
            handleClose();
        }
    };
    const changeFamilyMemberProfilePhoto = (file) => {
        state.familymemberPicUrl.set(file);
        if (file.size >= 5000000) {
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: 'Image File is too big',
            });
        } else {
            state.familymemberPicUrlsrc.set(URL.createObjectURL(file));
            handleFamilyMemebrClose();
        }
    };
    const handleAgentRoomChange = (RoomValue) => { 
        state.agentRoomRequestAccepted.set(RoomValue);
        setAgentRoomRequestError('')
        handleDisableBtn()
    }
    return (
        <Box sx={{ width: '100%', margin: '12px' }}>
            <Box sx={{ ml: 2, mt: 2 }}>
                <Title
                    title={Helper.getModuleName(
                        eventInfo ? eventInfo.moduleDetails : [],
                        AppConstants.EVENT_MODULES.COMBINE_REGISTRATION
                    )}
                    header={true}
                />
                {moduleIndex.get() >= 0 &&
                    props.eventStateDetail.eventDetail.moduleDetails[
                        moduleIndex.get()
                    ].details != null ? (
                    <DetailsComponent
                        data={
                            props.eventStateDetail.eventDetail.moduleDetails[
                                moduleIndex.get()
                            ].details
                        }
                    />
                ) : null}
            </Box>
            <Box className="contentBox">
                {/* <Paper sx={{ width: '100%', mb: 2 }}> */}
                {/* <Paper sx={{ pl: 2, pr: 2, pb: 2 }}> */}
                {/* <Typography
                        variant="h4"
                        fontSize={20}
                        fontWeight={600}
                        color="primary"
                        noWrap
                        component="div"
                        py={2}>
                        Event Registration
                    </Typography> */}
                {/* <AppBar position="static" color="default" sx={appBarStyle}>
                        <Title
                            title={'REGISTRATION FORM'}
                            // addicon="land"
                            sx={{
                                ml: 1,
                            }}
                        />
                    </AppBar> */}
                <Box component="div" sx={{ width: '100%' }}>
                    <Box sx={{ width: '100%' }}>
                        <Grid
                            container
                            rowSpacing={2}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item container>
                                <Grid item md={4}></Grid>
                                <Grid item xs={12} md={4}>
                                    <ParticipantAutoList
                                        disableParticipant={
                                            props.data && props.data
                                                ? true
                                                : false
                                        }
                                        participant={participant}
                                        setParticipant={changeParticipant}
                                        participantList={props.participantList ? props.participantList : participantList}
                                        modPermission={props.modPermission}
                                    />
                                </Grid>
                                <Grid item md={4}></Grid>
                            </Grid>
                            <Grid item lg={6} md={6} xs={12}>
                                <TextField
                                    size="small"
                                    label="First Name"
                                    required
                                    disabled={!checkEditPermission}
                                    fullWidth
                                    minRows={2}
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={state.firstName.get()}
                                    onBlur={() =>
                                        params.userID > 0
                                            ? null
                                            : validateFirstName()
                                    }
                                    onChange={(event) => {
                                        state.firstName.set(event.target.value);
                                        validateFirstName();
                                        handleDisableBtn();
                                    }}
                                    inputProps={{ maxLength: 50 }}
                                    error={
                                        firstNameErr.length > 0 ? true : false
                                    }
                                    helperText={
                                        firstNameErr.length > 0
                                            ? firstNameErr
                                            : ''
                                    }
                                />{' '}
                            </Grid>
                            <Grid item lg={6} md={6} xs={12}>
                                <TextField
                                    size="small"
                                    required
                                    disabled={!checkEditPermission}
                                    fullWidth
                                    onBlur={() =>
                                        params.userID > 0
                                            ? null
                                            : validatelastName()
                                    }
                                    label="Last Name"
                                    id="outlined-basic"
                                    variant="outlined"
                                    value={state.lastName.get()}
                                    onChange={(event) => {
                                        state.lastName.set(event.target.value);
                                        validatelastName();
                                        handleDisableBtn();
                                    }}
                                    inputProps={{ maxLength: 50 }}
                                    error={
                                        lasttNameErr.length > 0 ? true : false
                                    }
                                    helperText={
                                        lasttNameErr.length > 0
                                            ? lasttNameErr
                                            : ''
                                    }
                                />{' '}
                            </Grid>
                            <Grid item lg={6} md={6} xs={12}>
                                <MUIDatePicker
                                    label={'Date of Birth'}
                                    //maxDate={new Date()}
                                    value={state.dob.attach(Downgraded).get()}
                                    error={dobErr}
                                    setValue={(newDob) => {
                                        state.dob.set(
                                            dayjs(newDob).format('YYYY-MM-DD')
                                        );
                                        handleBlur(
                                            dayjs(newDob).format('YYYY-MM-DD')
                                        );
                                        handleDisableBtn();
                                    }}
                                    disabled={!checkEditPermission}
                                    disableFuture={true}
                                />
                                {/* <LocalizationProvider
                                        dateAdapter={AdapterDateFns}>
                                        <DesktopDatePicker
                                            label="Date of Birth"
                                            disabled={!checkEditPermission}
                                            maxDate={new Date()}
                                            value={state.dob
                                                .attach(Downgraded)
                                                .get()}
                                            inputProps={{ readOnly: true }}
                                            onChange={(newDob) => {
                                                state.dob.set(
                                                    Helper.FormatDate(newDob)
                                                );
                                                handleBlur(
                                                    Helper.FormatDate(newDob)
                                                );
                                                handleDisableBtn();
                                            }}
                                            renderInput={(params) => (
                                                <TextField
                                                    size="small"
                                                    {...params}
                                                    required
                                                    helperText={dobErr}
                                                    error={
                                                        dobErr.length > 0
                                                            ? true
                                                            : false
                                                    }
                                                />
                                            )}
                                        />
                                    </LocalizationProvider> */}
                            </Grid>
                            <Grid item lg={6} md={6} xs={12}>
                                <TextField
                                    error={emailErr.length > 0 ? true : false}
                                    required
                                    fullWidth
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    label=" Participant Email"
                                    onChange={(e) => {
                                        const email = e.target.value;
                                        state.email.set(email);
                                        ValidateEmail();
                                        handleDisableBtn();
                                    }}
                                    disabled={
                                        !checkEditPermission
                                            ? !checkEditPermission
                                            : params.userID > 0
                                                ? true
                                                : false
                                    }
                                    inputProps={{ maxLength: 250 }}
                                    helperText={emailErr}
                                    value={state.email.get()}
                                    onBlur={ValidateEmail}
                                />
                            </Grid>
                            <Grid item lg={6} md={6} xs={12}>
                                <PhoneNumber
                                    name={'combineRegistrationContact'}
                                    placeholder="Participant Contact No*"
                                    value={state.contactNo.get()}
                                    onChange={checkValidPhone}
                                    required={true}
                                    helperText={phoneError}
                                    error={phoneError.length > 0 ? true : false}
                                    disabled={
                                        !checkEditPermission
                                            ? !checkEditPermission
                                            : params.userID > 0
                                                ? true
                                                : false
                                    }
                                />
                            </Grid>
                            <Grid item lg={6} md={6} xs={12}>
                                <TextField
                                    fullWidth
                                    required
                                    multiline
                                    minRows={3}
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    disabled={!checkEditPermission}
                                    label="Participant Mailing Address"
                                    onBlur={checkMailingAddressValid}
                                    inputProps={{ maxLength: 500 }}
                                    error={
                                        mailingError.length > 0 ? true : false
                                    }
                                    helperText={mailingError}
                                    value={state.mailingAddress.get()}
                                    onChange={(event) => {
                                        state.mailingAddress.set(
                                            event.target.value
                                        );
                                        handleDisableBtn();
                                    }}
                                />
                            </Grid>
                        </Grid>
                        <Divider
                            sx={{ mt: 2, marginRight: 0, mb: 2 }}
                            flexItem
                        />
                    </Box> 
                    {state.eventForm.attach(Downgraded).get() &&
                        state.eventForm.attach(Downgraded).get() !== null &&
                        state.eventForm.attach(Downgraded).get().Type && (
                            <>
                                <Box sx={{ padding: 0, mb: 2 }}>
                                    <Typography fontWeight={600}>
                                        {
                                            state.eventForm
                                                .attach(Downgraded)
                                                .get().Title
                                        }
                                        *
                                    </Typography>
                                    {state.eventForm.get().Type === 'Option' ? (
                                        <FormControl>
                                            <RadioGroup
                                                aria-labelledby="demo-radio-buttons-group-label"
                                                onChange={handleRadioChange}
                                                value={
                                                    state.eventForm
                                                        .attach(Downgraded)
                                                        .get()
                                                        .FormFields?.find(
                                                            (x) =>
                                                                x.FieldValue ===
                                                                true
                                                        )
                                                        ? state.eventForm
                                                            .attach(
                                                                Downgraded
                                                            )
                                                            .get()
                                                            .FormFields?.find(
                                                                (x) =>
                                                                    x.FieldValue ===
                                                                    true
                                                            )?.FieldName
                                                        : ''
                                                }
                                                name="radio-buttons-group">
                                                {state.eventForm
                                                    .attach(Downgraded)
                                                    .get()?.FormFields &&
                                                    state.eventForm
                                                        .attach(Downgraded)
                                                        .get()
                                                        ?.FormFields?.map(
                                                            (item, index) => {
                                                                return (
                                                                    <FormControlLabel
                                                                        disabled={
                                                                            !checkEditPermission
                                                                        }
                                                                        key={
                                                                            index
                                                                        }
                                                                        value={
                                                                            item.FieldName
                                                                        }
                                                                        control={
                                                                            <Radio />
                                                                        }
                                                                        label={
                                                                            item.Description
                                                                        }
                                                                        className={classes.radioLabel}
                                                                    />
                                                                );
                                                            }
                                                        )}
                                            </RadioGroup>
                                        </FormControl>
                                    ) : (
                                        <FormGroup>
                                            {state.eventForm
                                                .attach(Downgraded)
                                                .get()?.FormFields &&
                                                state.eventForm
                                                    .attach(Downgraded)
                                                    .get()
                                                    ?.FormFields?.map(
                                                        (item, index) => {
                                                            return (
                                                                <FormControlLabel
                                                                    key={index}
                                                                    control={
                                                                        <Checkbox
                                                                            checked={
                                                                                item.FieldValue
                                                                            }
                                                                            disabled={
                                                                                !checkEditPermission
                                                                            }
                                                                            name={
                                                                                item.FieldName
                                                                            }
                                                                            onChange={
                                                                                handleCheckBoxChange
                                                                            }
                                                                        />
                                                                    }
                                                                    label={
                                                                        item.Description
                                                                    }
                                                                />
                                                            );
                                                        }
                                                    )}
                                        </FormGroup>
                                    )}
                                    {/* <Grid>
                                        <Checkbox
                                            checked={state.checkBox1.get()}
                                            onChange={(e) =>
                                                state.checkBox1.set(e.target.checked)
                                            }
                                            disabled={!checkEditPermission}
                                        />
                                        <span>
                                            I will attend the NBA Draft Combine (May 15-22) and
                                            fully participate (five-on-five games, shooting
                                            drills, strength and agility testing and medical
                                            examinations).
                                        </span>
                                    </Grid>
                                    <Grid>
                                        <Checkbox
                                            checked={state.checkBox2.get()}
                                            onChange={(e) =>
                                                state.checkBox2.set(e.target.checked)
                                            }
                                            disabled={!checkEditPermission}
                                        />
                                        <span>
                                            I will attend the NBA Draft Combine (May 15-22) and
                                            will participate in the shooting drills, strength
                                            and agility testing and medical examinations, but
                                            will NOT participate in the five-on-five games.
                                        </span>
                                    </Grid>
                                    <Grid>
                                        <Checkbox
                                            checked={state.checkBox3.get()}
                                            onChange={(e) =>
                                                state.checkBox3.set(e.target.checked)
                                            }
                                            disabled={!checkEditPermission}
                                        />
                                        <span>
                                            I will attend the NBA Draft Combine (May 15-22) and
                                            will participate in strength and agility testing and
                                            medical examinations, but will NOT participate in
                                            five-on-five games or shooting drills.
                                        </span>
                                    </Grid>
                                    <Grid>
                                        <Checkbox
                                            checked={state.checkBox4.get()}
                                            onChange={(e) =>
                                                state.checkBox4.set(e.target.checked)
                                            }
                                            disabled={!checkEditPermission}
                                        />
                                        <span>I cannot attend the NBA Draft Combine.</span>
                                    </Grid> */}
                                    {/* <Grid sx={{ textAlign: 'right' }}>
                                    <Button variant="contained">I Agree</Button>
                                    </Grid> */}
                                    {state.eventForm.get() !== null &&
                                        state.eventForm
                                            .get()
                                            .FormFields.find(
                                                (x) =>
                                                    x.FieldValue === true &&
                                                    x.FieldName === 'NotAttend'
                                            ) && (
                                            <Box sx={{ width: '100%', mt: 1 }}>
                                                {' '}
                                                <TextField
                                                    //error={emailErr.length > 0 ? true : false}
                                                    multiline
                                                    minRows={3}
                                                    fullWidth
                                                    required={
                                                        state.eventForm.get() !==
                                                            null &&
                                                            state.eventForm
                                                                .get()
                                                                .FormFields.find(
                                                                    (x) =>
                                                                        x.FieldValue ===
                                                                        true &&
                                                                        x.FieldName !==
                                                                        'NotAttend'
                                                                )
                                                            ? false
                                                            : true
                                                    }
                                                    size="small"
                                                    disabled={
                                                        !checkEditPermission
                                                    }
                                                    id="outlined-basic"
                                                    variant="outlined"
                                                    error={
                                                        reasonErr.length > 0
                                                            ? true
                                                            : false
                                                    }
                                                    // helperText={
                                                    //     reasonErr.length > 0
                                                    //         ? reasonErr
                                                    //         : ''
                                                    // }
                                                    placeholder=" Please list the day(s) of the NBA Draft Combine that you are unable to attend and the reason you are unable to attend.
                                                    The NBA will review this information and inform you whether your absence is excused."
                                                    label={state.reason.get().length > 0 ? "Please list the day(s) of the NBA Draft Combine that you are unable to attend and the reason you are unable to attend.The NBA will review this information and inform you whether your absence is excused." : ""}
                                                    
                                                    onChange={(event) => {
                                                        state.reason.set(
                                                            event.target.value
                                                        );
                                                        handleDisableBtn();
                                                    }}
                                                    onBlur={validateReason}
                                                    value={state.reason.get()}
                                                    InputProps={{ style: {  
                                                        color: 'black',
                                                        fontWeight:'500'
                                                      } }}
                                                />
                                            </Box>
                                        )}
                                </Box>
                                <Divider
                                    sx={{ mt: 2, marginRight: 0, mb: 2 }}
                                    flexItem
                                />
                                {state.eventForm.get() !== null &&
                                        state.eventForm
                                            .get()
                                            .FormFields.find(
                                                (x) =>
                                                    x.FieldValue === true &&
                                                    x.FieldName !== 'NotAttend'
                                            ) && <>
                                    <Grid item lg={12} md={12} xs={12} sx={{ height: '40px', color: 'red' }}>As a reminder, your participation in each of the below activities is optional:</Grid>
                                    <Grid item lg={12} md={12} xs={12} sx={{ height: '50px' }}>
                                        <Box variant="div">
                                            <span><b>Do you plan on participating in Five-on-Five Scrimmages?</b></span>
                                            <FormControl
                                                size="small"
                                                sx={{ width: '120px', mt: -1 }}
                                                error={participateInFiveOnFiveErr.length > 0 ? true : false}
                                            >
                                                <InputLabel sx={{ ml: 2 }} id="NBA-Draft-label">Select</InputLabel>
                                                <Select
                                                    labelId="NBA-Draft-label"
                                                    id="NBA-Draft-id"
                                                    value={state.participateInFiveOnFive.get()}
                                                    label="NBA Draft"
                                                    size="small"
                                                    sx={{ ml: 2 }}
                                                    onChange={(e) => {
                                                        state.participateInFiveOnFive.set(
                                                            e.target.value
                                                        );
                                                        if (e.target.value) {
                                                            setParticipateInFiveOnFiveErr("")
                                                        } else if (!e.target.value) {
                                                            setParticipateInFiveOnFiveErr("")
                                                        } else {
                                                            setParticipateInFiveOnFiveErr("please select")
                                                        }
                                                        handleDisableBtn();
                                                    }}
                                                >
                                                    <MenuItem value={""}>Select</MenuItem>
                                                    <MenuItem value={true}>Yes</MenuItem>
                                                    <MenuItem value={false}>No</MenuItem>

                                                </Select>
                                            </FormControl>
                                            {participateInFiveOnFiveErr.length > 0 ? <span style={{ marginLeft: '10px', color: '#D62F2F' }}>Please select one option</span> : ''}
                                        </Box>
                                    </Grid>
                                    <Grid item lg={12} md={12} xs={12} sx={{ height: '50px' }}>
                                        <Box variant="div">
                                            <span><b>Do you plan on participating in Live Action Offense vs Defense Drills?</b></span>
                                            <FormControl
                                                size="small"
                                                sx={{ width: '120px', mt: -1 }}
                                                error={defenceDrillsErr.length > 0 ? true : false}
                                            >
                                                <InputLabel sx={{ ml: 2 }} id="NBA-Draft-label">Select</InputLabel>
                                                <Select
                                                    labelId="NBA-Draft-label"
                                                    id="NBA-Draft-id"
                                                    value={state.defenceDrills.get()}
                                                    label="NBA Draft"
                                                    size="small"
                                                    sx={{ ml: 2 }}
                                                    onChange={(e) => {
                                                        state.defenceDrills.set(
                                                            e.target.value
                                                        );
                                                        if (e.target.value) {
                                                            setDefenceDrillsErr("")
                                                        } else if (!e.target.value) {
                                                            setDefenceDrillsErr("")
                                                        } else {
                                                            setDefenceDrillsErr("please select")
                                                        }

                                                        handleDisableBtn();
                                                    }}
                                                >
                                                    <MenuItem value={""}>Select</MenuItem>
                                                    <MenuItem value={true}>Yes</MenuItem>
                                                    <MenuItem value={false}>No</MenuItem>
                                                </Select>
                                            </FormControl>
                                            {defenceDrillsErr.length > 0 ? <span style={{ marginLeft: '10px', color: '#D62F2F' }}>Please select one option</span> : ''}
                                        </Box>
                                    </Grid> </>}
                            </>
                        )}
                    <Box component="div" sx={{ width: '100%' }}>

                        <Grid
                            container
                            alignItems="center"
                            rowSpacing={2}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            {showAgentProParticipant &&
                                <><AppBar
                                    position="static"
                                    color="default"
                                    sx={appBarStyle}>
                                    <Title
                                        title={agentProParticipantText?.[0].nbaDraftTitle}
                                        // addicon="land"
                                        sx={{
                                            ml: 1,
                                            mt: 0.5,
                                        }}
                                    />
                                </AppBar>
                                    <Grid item lg={12} md={12} xs={12}>
                                        <Box sx={{ mb: 4 }}>
                                            {agentProParticipantText?.[0].nbaDraftDescription}
                                        </Box>
                                        <Box variant="div">

                                            <span>{agentProParticipantText?.[0].nbaDraftQuestionText}</span>
                                            <FormControl
                                                size="small"
                                                sx={{ width: '120px', mt: -1 }}
                                                error={attendingNBADraftErr}
                                            >
                                                <InputLabel sx={{ ml: 2 }} id="NBA-Draft-label">Select</InputLabel>
                                                <Select
                                                    labelId="NBA-Draft-label"
                                                    id="NBA-Draft-id"
                                                    value={state.attendingDraftNBA.get()}
                                                    label="NBA Draft"
                                                    size="small"
                                                    sx={{ ml: 2 }}
                                                    onChange={(e) => {
                                                        state.attendingDraftNBA.set(
                                                            e.target.value
                                                        );
                                                        setAttendingNBADraftErr(false)
                                                        handleDisableBtn();
                                                    }}
                                                >
                                                    <MenuItem value={""}>Select</MenuItem>
                                                    <MenuItem value={true}>Yes</MenuItem>
                                                    <MenuItem value={false}>No</MenuItem>

                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </Grid></>}
                            {showAgentProParticipant && (
                                <>
                                    <AppBar
                                        position="static"
                                        color="default"
                                        sx={appBarStyle}>
                                        <Title
                                        title={agentProParticipantText?.[1].nbaProDayTitle}
                                        // addicon="land"
                                            sx={{
                                                ml: 1,
                                                mt: 0.5,
                                            }}
                                        />
                                    </AppBar>
                                    <Grid item lg={12} md={12} xs={12}>
                                        {agentProParticipantText?.[1].nbaProDayDescription ? <Box sx={{ mb: 4 }}>
                                            {agentProParticipantText?.[1].nbaProDayDescription}
                                        </Box> : null}
                                        {/* <FormGroup
                                            sx={{ alignContent: 'flex-start', ml: '-15px' }}>
                                            <FormControlLabel
                                                sx={{ p: 0, mb: 0 }}
                                                labelPlacement="start"
                                                control={
                                                    <Switch
                                                        disabled={
                                                            !checkEditPermission
                                                        }
                                                        checked={state.agentProDayParticipant.get()}
                                                        onChange={(e) => {
                                                            state.agentProDayParticipant.set(
                                                                e.target.checked
                                                            );
                                                            handleDisableBtn();
                                                        }}
                                                    />
                                                }
                                                label="Are you planning to participate in an agent Pro Day?"
                                            />
                                        </FormGroup> */}
                                        <Box variant="div">{agentProParticipantText?.[1].nbaProDayQuestionText }
                                            <FormControl
                                                size="small"
                                                error={agentProdDayErr}
                                                sx={{ width: '120px', mt: -1 }}
                                            >
                                                <InputLabel sx={{ ml: 2 }} id="pro-day-label">Select</InputLabel>
                                                <Select
                                                    labelId="pro-day-label"
                                                    id="pro-day-id"
                                                    value={state.agentProDayParticipant.get()}
                                                    label="NBA Draft"
                                                    size="small"
                                                    sx={{ ml: 2 }}
                                                    onChange={(e) => {
                                                        state.agentProDayParticipant.set(
                                                            e.target.value);
                                                        handleDisableBtn();
                                                        setAgentProdDayErr(false)
                                                    }
                                                    }
                                                >
                                                    <MenuItem value={""}>Select</MenuItem>
                                                    <MenuItem value={true}>Yes</MenuItem>
                                                    <MenuItem value={false}>No</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </Box>
                                    </Grid>
                                </>
                            )}
                            {state.agentProDayParticipant.get() && cities.length > 0 && (
                                <Grid item lg={12} md={12} xs={12} sx={{
                                    paddingTop: '0px',
                                    '& .MuiGrid-item': { paddingTop: '0px' },
                                }}>
                                    <FormControl sx={{ marginTop: '-15px' }}>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-radio-buttons-group-label"
                                            onChange={cityChange}
                                            value={
                                                cities.find(
                                                    (x) => x.select === true
                                                )
                                                    ? cities.find(
                                                        (x) =>
                                                            x.select === true
                                                    )?.label
                                                    : ''
                                            }
                                            name="radio-buttons-group">
                                            {cities.map((item, index) => {
                                                return (
                                                    <FormControlLabel
                                                        disabled={
                                                            !checkEditPermission
                                                        }
                                                        key={index}
                                                        value={item.label}
                                                        control={<Radio />}
                                                        label={item.label}
                                                    />
                                                );
                                            })}
                                        </RadioGroup>
                                    </FormControl>
                                </Grid>
                            )}

                            <AppBar
                                position="static"
                                color="default"
                                sx={appBarStyle}>
                                <Title
                                    title={'Additional Contact Information:'}
                                    // addicon="land"
                                    sx={{
                                        ml: 1,
                                        mt: 1,
                                    }}
                                />
                            </AppBar>
                        </Grid>
                        <Grid
                            container
                            alignItems="center"
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                            sx={{ backgroundColor: '#D3D3D3', padding: '3px' }}
                        >
                            <Grid item lg={4} md={4} xs={12}>
                                <Typography fontWeight={600}>
                                    Certified Agent
                                </Typography>
                            </Grid>
                            <Grid item lg={6} md={6} xs={12}>

                                <FormGroup
                                    sx={{ alignContent: 'flex-start' }}>
                                    <FormControlLabel
                                        sx={{ p: 0, m: 0 }}
                                        labelPlacement="start"
                                        control={
                                            <Switch
                                                disabled={
                                                    !checkEditPermission
                                                }
                                                checked={state.isCertifiedAgentAttend.get()}
                                                onChange={(e) => {
                                                    onChangeCertifiedAgentAttend(e)
                                                }}
                                            />
                                        }
                                        label="I do not have a certified agent at this time"
                                    />
                                </FormGroup>

                            </Grid>
                            <Grid item lg={2} md={2} xs={12}></Grid>
                        </Grid>
                        <Grid
                            container
                            alignItems="center"
                            rowSpacing={1}
                            sx={{ mt: 1 }}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item lg={4} md={4} xs={12}>
                                <TextField
                                    fullWidth
                                    required={state.isCertifiedAgentAttend.get() ? false : true}
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    label="Certified Agent Name  "
                                    inputProps={{ maxLength: 200 }}
                                    disabled={!checkEditPermission}
                                    value={state.certifiedagentContactName.get()}
                                    onBlur={() => {
                                        (params.userID > 0 || state.isCertifiedAgentAttend.get())
                                            ? null
                                            : validateAltName()
                                    }
                                    }
                                    error={altNameErr.length > 0 ? true : false}
                                    helperText={
                                        altNameErr.length > 0 ? altNameErr : ''
                                    }
                                    onChange={(event) => {
                                        state.certifiedagentContactName.set(
                                            event.target.value
                                        );
                                        state.isCertifiedAgentAttend.get() ? null : validateAltName();
                                        handleDisableBtn();
                                    }}
                                />
                            </Grid>
                            <Grid item lg={4} md={4} xs={12}>
                                <TextField
                                    error={
                                        altEmailErr.length > 0 ? true : false
                                    }
                                    helperText={
                                        altEmailErr.length > 0
                                            ? altEmailErr
                                            : ''
                                    }
                                    fullWidth
                                    required={state.isCertifiedAgentAttend.get() ? false : true}
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    onChange={(e) => {
                                        const email = e.target.value;
                                        state.certifiedagentContactEmail.set(email);
                                        state.isCertifiedAgentAttend.get() ? null : ValidateAlternateEmail();
                                        handleDisableBtn();
                                    }}
                                    disabled={!checkEditPermission}
                                    label="Certified Agent Email"
                                    inputProps={{ maxLength: 255 }}
                                    value={state.certifiedagentContactEmail.get()}
                                    onBlur={state.isCertifiedAgentAttend.get() ? null : ValidateAlternateEmail}
                                />
                            </Grid>
                            <Grid item lg={4} md={4} xs={12}>
                                <PhoneNumber
                                    name={'combineRegistrationContact'}
                                    placeholder={'Certified Agent No'}
                                    value={state.certifiedagentContactNo.get()}
                                    onChange={(val) => state.isCertifiedAgentAttend.get() ? state.certifiedagentContactNo.set(val) : checkAltValidPhone(val)}
                                    required={state.isCertifiedAgentAttend.get() ? false : true}
                                    helperText={altPhoneError}
                                    error={
                                        altPhoneError.length > 0 ? true : false
                                    }
                                    disabled={
                                        !checkEditPermission
                                            ? !checkEditPermission
                                            : params.userID > 0
                                                ? true
                                                : false
                                    }
                                />
                            </Grid>
                             
                            {!state.isCertifiedAgentAttend.get() && eventInfo.eventID !== eliteConfigEventID ? <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginLeft: 3 }}>
                                <Box><Typography variant="subtitle2" color={'primary'} component={'span'}>{AppConstants.HOTEL_AGENT_ROOM_CONFIRM_TEXT}</Typography></Box>
                                <Box sx={{ marginLeft: 2 }}>
                                    <FormControl variant="standard">
                                        <RadioGroup aria-label="position" name="position"
                                            value={state.agentRoomRequestAccepted.get() != null && state.agentRoomRequestAccepted.get() !== '' ?
                                                state.agentRoomRequestAccepted.get() == 1 ? 'Yes' : 'No' : ''}
                                            onChange={(e) => {
                                                //console.log('checked', e.target.value)
                                                handleAgentRoomChange(e.target.value == 'Yes' ? true : false)
                                            }} row >

                                            <FormControlLabel value={'Yes'}
                                                control={<Radio color="primary" size="small" />}
                                                label="Yes" />

                                            <FormControlLabel value={'No'}
                                                control={<Radio color="primary" size="small" />}
                                                label="No" />
                                        </RadioGroup>
                                        <FormHelperText sx={{ color: 'red' }}>{agentRoomRequestError}</FormHelperText>
                                    </FormControl>
                                </Box>
                            </Box>:null}
                                 
                        </Grid>
                        <Divider
                            light={false}
                            sx={{ mt: 1, marginRight: 0, mb: 2 }}
                            flexItem
                        />
                        <Grid
                            container
                            alignItems="center"
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                            sx={{ backgroundColor: '#D3D3D3', padding: '3px' }}
                        >
                            <Grid item lg={12} md={12} xs={12}>
                                <Typography fontWeight={600}>
                                    School/Club Athletic Director and/or Compliance Officer Contact
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            alignItems="center"
                            rowSpacing={1}
                            sx={{ mt: 1 }}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item lg={6} md={6} xs={12}>
                                <TextField
                                    fullWidth
                                    required={true}
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    label="Athletic Director/Compliance Officer Name"
                                    inputProps={{ maxLength: 200 }}
                                    disabled={!checkEditPermission}
                                    value={state.athleticDirectorName.get()}
                                    onBlur={() => {
                                        (params.userID > 0)
                                            ? null
                                            : validateAthleticDirectorName()
                                    }
                                    }
                                    error={athleticDirectorNameErr.length > 0 ? true : false}
                                    helperText={
                                        athleticDirectorNameErr.length > 0 ? athleticDirectorNameErr : ''
                                    }
                                    onChange={(event) => {
                                        state.athleticDirectorName.set(
                                            event.target.value
                                        );
                                        validateAthleticDirectorName();
                                        handleDisableBtn();
                                    }}
                                />
                            </Grid>
                            <Grid item lg={6} md={6} xs={12}>
                                <TextField
                                    error={
                                        athleticDirectorEmailErr.length > 0 ? true : false
                                    }
                                    helperText={
                                        athleticDirectorEmailErr.length > 0
                                            ? athleticDirectorEmailErr
                                            : ''
                                    }
                                    fullWidth
                                    required={true}
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    onChange={(e) => {
                                        const email = e.target.value;
                                        state.athleticDirectorEmail.set(email);
                                        ValidateAthleticDirectorEmail();
                                        handleDisableBtn();
                                    }}
                                    disabled={!checkEditPermission}
                                    label="Athletic Director/Compliance Officer Email"
                                    inputProps={{ maxLength: 255 }}
                                    value={state.athleticDirectorEmail.get()}
                                    onBlur={ValidateAthleticDirectorEmail}
                                />
                            </Grid>
                        </Grid>
                        <Divider
                            sx={{ mt: 1, marginRight: 0, mb: 2 }}
                            flexItem
                        />
                        <Grid
                            container
                            alignItems="center"
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                            sx={{ backgroundColor: '#D3D3D3', padding: '3px' }}
                        >
                            <Grid item lg={12} md={12} xs={12}>
                                <Typography fontWeight={600}>
                                    School/Club Men’s Basketball Administrator Contact
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            alignItems="center"
                            rowSpacing={1}
                            sx={{ mt: 1 }}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item lg={4} md={4} xs={12}>
                                <TextField
                                    fullWidth
                                    required={true}
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    label="Basketball Admin Name"
                                    inputProps={{ maxLength: 200 }}
                                    disabled={!checkEditPermission}
                                    value={state.basketballAdminName.get()}
                                    onBlur={() => {
                                        (params.userID > 0)
                                            ? null
                                            : validateBasketballAdminName()
                                    }
                                    }
                                    error={basketballAdminNameErr.length > 0 ? true : false}
                                    helperText={
                                        basketballAdminNameErr.length > 0 ? basketballAdminNameErr : ''
                                    }
                                    onChange={(event) => {
                                        state.basketballAdminName.set(
                                            event.target.value
                                        );
                                        validateBasketballAdminName();
                                        handleDisableBtn();
                                    }}
                                />
                            </Grid>
                            <Grid item lg={4} md={4} xs={12}>
                                <TextField
                                    error={
                                        basketballAdminEmailErr.length > 0 ? true : false
                                    }
                                    helperText={
                                        basketballAdminEmailErr.length > 0
                                            ? basketballAdminEmailErr
                                            : ''
                                    }
                                    fullWidth
                                    required={true}
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    onChange={(e) => {
                                        const email = e.target.value;
                                        state.basketballAdminEmail.set(email);
                                        ValidateBasketballAdminEmail();
                                        handleDisableBtn();
                                    }}
                                    disabled={!checkEditPermission}
                                    label="Basketball Admin Email"
                                    inputProps={{ maxLength: 255 }}
                                    value={state.basketballAdminEmail.get()}
                                    onBlur={ValidateBasketballAdminEmail}
                                />
                            </Grid>
                            <Grid item lg={4} md={4} xs={12}>
                                <PhoneNumber
                                    name={'basketballAdminContact'}
                                    placeholder={'Basketball Admin Number'}
                                    value={state.basketballAdminContactNo.get()}
                                    onChange={(val) => checkBasketballAdminValidPhone(val)}
                                    required={true}
                                    helperText={basketballAdminContactNoError}
                                    error={
                                        basketballAdminContactNoError.length > 0 ? true : false
                                    }
                                    disabled={
                                        !checkEditPermission
                                            ? !checkEditPermission
                                            : params.userID > 0
                                                ? true
                                                : false
                                    }
                                /></Grid>
                        </Grid>
                        <Divider
                            sx={{ mt: 1, marginRight: 0, mb: 2 }}
                            flexItem
                        />
                        {/* <Grid
                            container
                            alignItems="center"
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                            sx={{ backgroundColor: '#D3D3D3' }}
                        >
                            <Grid item lg={4} md={4} xs={12} >
                                <Typography fontWeight={600}>
                                    Family Member Contact
                                </Typography>
                            </Grid>
                            <Grid item lg={7} md={7} xs={12} >
                                     <FormGroup
                                        sx={{ alignContent: 'flex-start' }}>
                                        <FormControlLabel
                                            sx={{ p: 0, m: 0 }}
                                            labelPlacement="start"
                                            control={
                                                <Switch
                                                    disabled={
                                                        !checkEditPermission
                                                    }
                                                    checked={state.isFamilyMemberAttend.get()}
                                                    onChange={(e) => {
                                                        onChangeFamilyMemberContact(e)
                                                    }}
                                                />
                                            }
                                            label="I do not have a Family member Attending with me"
                                        />
                                    </FormGroup>
                             </Grid>
                            <Grid item lg={1} md={1} xs={12}></Grid>
                        </Grid>
                        <Grid
                            container
                            alignItems="center"
                            rowSpacing={1}
                            sx={{ mt: 1 }}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item lg={4} md={4} xs={12}>
                                <TextField
                                    fullWidth
                                    required={
                                        (state.eventForm.get() !== null &&
                                            state.eventForm
                                                .get()
                                                .FormFields.find(
                                                    (x) =>
                                                        x.FieldValue === true &&
                                                        x.FieldName === 'NotAttend'
                                                )) || state.isFamilyMemberAttend.get()
                                            ? false
                                            : true
                                    }
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    label="Family Member Name"
                                    inputProps={{ maxLength: 200 }}
                                    disabled={!checkEditPermission}
                                    value={state.familymemberContactName.get()}
                                    onBlur={() =>{
                                        (params.userID > 0 || state.isFamilyMemberAttend.get())
                                            ? null
                                            : ValidateFamilyMemberName()}
                                    }
                                    error={famMemNameErr.length > 0 ? true : false}
                                    helperText={
                                        famMemNameErr.length > 0 ? famMemNameErr : ''
                                    }
                                    onChange={(event) => {
                                        state.familymemberContactName.set(
                                            event.target.value
                                        );
                                        state.isFamilyMemberAttend.get() ? null : ValidateFamilyMemberName();
                                        handleDisableBtn();
                                    }}
                                />
                            </Grid>
                            <Grid item lg={4} md={4} xs={12}>
                                <TextField
                                    error={
                                        famMemEmailErr.length > 0 ? true : false
                                    }
                                    helperText={
                                        famMemEmailErr.length > 0
                                            ? famMemEmailErr
                                            : ''
                                    }
                                    fullWidth
                                    required={
                                        (state.eventForm.get() !== null &&
                                            state.eventForm
                                                .get()
                                                .FormFields.find(
                                                    (x) =>
                                                        x.FieldValue === true &&
                                                        x.FieldName === 'NotAttend'
                                                )) || state.isFamilyMemberAttend.get()
                                            ? false
                                            : true
                                    }
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    onChange={(e) => {
                                        const email = e.target.value;
                                        state.familymemberEmail.set(email);
                                        state.isFamilyMemberAttend.get() ? null : ValidateFamilyMemberEmail();
                                        handleDisableBtn();
                                    }}
                                    disabled={!checkEditPermission}
                                    label="Family Member Email"
                                    inputProps={{ maxLength: 255 }}
                                    value={state.familymemberEmail.get()}
                                    onBlur={state.isFamilyMemberAttend.get() ? null : ValidateFamilyMemberEmail}
                                />
                            </Grid>
                            <Grid item lg={3} md={3} xs={12}>
                                <PhoneNumber
                                    name={'combineRegistrationContact'}
                                    placeholder={
                                        state.eventForm.get() !== null &&
                                            state.eventForm
                                                .get()
                                                .FormFields.find(
                                                    (x) =>
                                                        x.FieldValue === true &&
                                                        x.FieldName === 'NotAttend'
                                                )
                                            ? 'Family Member Contact No'
                                            : 'Family Member Contact No*'
                                    }
                                    value={state.familymemberContactNo.get()}
                                    onChange={(val) => state.isFamilyMemberAttend.get() ? state.familymemberContactNo.set(val) : checkfamilyValidPhone(val)}
                                    required={true}
                                    helperText={famMemPhoneError}
                                    error={
                                        famMemPhoneError.length > 0 ? true : false
                                    }
                                    disabled={
                                        !checkEditPermission
                                            ? !checkEditPermission
                                            : params.userID > 0
                                                ? true
                                                : false
                                    }
                                />
                            </Grid>
                            <Grid item lg={1} md={1} xs={12} sx={{textAlign:'center', position:'relative', top:'-13px'}}>
                                <span style={{fontWeight:500, fontSize:10, textAlign:'center'}}>Upload Photo</span>
                                {state.familymemberPicUrlsrc.get() ? (
                                    <ProfileImage
                                        handleClick={handlefamilymemberImageUpload}
                                        src={state.familymemberPicUrlsrc.get()}
                                        width={40}
                                    />
                                ) : state.familymemberPicUrl.get() ? (
                                    <ProfileImage
                                        handleClick={handlefamilymemberImageUpload}
                                        src={state.familymemberPicUrl.get()}
                                        width={40}
                                    />
                                ) : (
                                    <ProfileImage
                                        handleClick={handlefamilymemberImageUpload}
                                        src={pic}
                                        width={40}
                                    />
                                )}

                            </Grid>
                        </Grid> */}
                        {/* <Divider
                            light={false}
                            sx={{ mt: 1, marginRight: 0, mb: 2 }}
                            flexItem
                        /> */}

                        {/* <Divider
                            light={false}
                            sx={{ mt: 2, marginRight: 0, mb: 2 }}
                            flexItem
                        /> */}
                        {/* <Grid
                            container
                            alignItems="flex-start"
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item lg={12} md={12} xs={12} sx={{ backgroundColor: '#D3D3D3' }}>
                                <Typography fontWeight={600} sx={{ mb: '10px' }}>
                                    School/Club Athletic Trainer Contact
                                </Typography>
                            </Grid>
                        </Grid> */}
                        <Grid
                            container
                            alignItems="center"
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}
                            sx={{ backgroundColor: '#D3D3D3' }}
                        >
                            <Grid item lg={4} md={4} xs={12} >
                                <Typography fontWeight={600}>
                                    School/Club Athletic Trainer Contact
                                </Typography>
                            </Grid>
                            <Grid item lg={7} md={7} xs={12} >
                                {/* <FormGroup
                                    sx={{ alignContent: 'flex-start' }}>
                                    <FormControlLabel
                                        sx={{ p: 0, m: 0 }}
                                        labelPlacement="start"
                                        control={
                                            <Switch
                                                disabled={
                                                    !checkEditPermission
                                                }
                                                checked={state.isFamilyMemberAttend.get()}
                                                onChange={(e) => {
                                                    onChangeFamilyMemberContact(e)
                                                }}
                                            />
                                        }
                                        label="I do not have a school/club athletic trainer at this time"
                                    />
                                </FormGroup> */}
                            </Grid>
                            <Grid item lg={1} md={1} xs={12}></Grid>
                        </Grid>
                        <Grid
                            container
                            alignItems="center"
                            rowSpacing={1}
                            sx={{ mt: 1 }}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item lg={4} md={4} xs={12}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    required={true}
                                    id="outlined-basic"
                                    variant="outlined"
                                    label="Athletic Trainer Name"
                                    inputProps={{ maxLength: 250 }}
                                    onBlur={() =>
                                        params.userID > 0
                                            ? null
                                            : validateAthName()
                                    }
                                    disabled={!checkEditPermission}
                                    error={athNameErr.length > 0 ? true : false}
                                    helperText={
                                        athNameErr.length > 0 ? athNameErr : ''
                                    }
                                    value={state.athleticTrainerName.get()}
                                    onChange={(event) => {
                                        state.athleticTrainerName.set(
                                            event.target.value
                                        );
                                        validateAthName();
                                        handleDisableBtn();
                                    }}
                                />
                            </Grid>
                            <Grid item lg={4} md={4} xs={12}>
                                <TextField
                                    error={
                                        athEmailErr.length > 0 ? true : false
                                    }
                                    fullWidth
                                    size="small"
                                    id="outlined-basic"
                                    required={true}
                                    onChange={(e) => {
                                        const email = e.target.value;
                                        state.athleticTrainerEmail.set(email);
                                        ValidateAthleticEmail();
                                        handleDisableBtn();
                                    }}
                                    variant="outlined"
                                    disabled={!checkEditPermission}
                                    label="Athletic Trainer Email"
                                    inputProps={{ maxLength: 255 }}
                                    helperText={
                                        athEmailErr.length > 0
                                            ? athEmailErr
                                            : ''
                                    }
                                    value={state.athleticTrainerEmail.get()}
                                    onBlur={ValidateAthleticEmail}
                                />
                            </Grid>
                            <Grid item lg={4} md={4} xs={12}>
                                <PhoneNumber
                                    name={'combineRegistrationContact'}
                                    placeholder={
                                        state.eventForm.get() !== null &&
                                            state.eventForm
                                                .get()
                                                .FormFields.find(
                                                    (x) =>
                                                        x.FieldValue === true &&
                                                        x.FieldName === 'NotAttend'
                                                )
                                            ? 'Athletic Trainer Cell'
                                            : 'Athletic Trainer Cell'
                                    }
                                    value={state.athleticTrainerCell.get()}
                                    onChange={checkAthValidPhone}
                                    required={true}
                                    helperText={athPhoneError}
                                    error={
                                        athPhoneError.length > 0 ? true : false
                                    }
                                    disabled={
                                        !checkEditPermission
                                            ? !checkEditPermission
                                            : params.userID > 0
                                                ? true
                                                : false
                                    }
                                />
                            </Grid>
                            {/* <Grid item lg={4} md={4} xs={12}>
                                <TextField
                                    //error={emailErr.length > 0 ? true : false}
                                    multiline
                                    minRows={3}
                                    fullWidth
                                    size="small"
                                    disabled={!checkEditPermission}
                                    id="outlined-basic"
                                    variant="outlined"
                                    label="Dietary restrictions (please list any dietary restrictions)"
                                    onChange={(event) => {
                                        state.dietRestrictions.set(
                                            event.target.value
                                        );
                                        handleDisableBtn();
                                    }}
                                    value={state.dietRestrictions.get()}
                                />
                            </Grid> */}
                        </Grid>
                        <Divider
                            sx={{ mt: 2, marginRight: 0, mb: 2 }}
                            flexItem
                        />
                        <Grid
                            container
                            alignItems="center"
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item lg={12} md={12} xs={12} sx={{ backgroundColor: '#D3D3D3' }} >
                                <Typography fontWeight={600} sx={{ mb: '10px' }}>
                                    Personal Physician (If Any)
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            alignItems="center"
                            rowSpacing={1}
                            sx={{ mt: 1 }}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item lg={4} md={4} xs={12}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    id="outlined-basic"
                                    variant="outlined"
                                    label="Personal Physician Name"
                                    inputProps={{ maxLength: 250 }}
                                    disabled={!checkEditPermission}
                                    value={state.personalphysicianContactName.get()}
                                    onChange={(event) => {
                                        state.personalphysicianContactName.set(
                                            event.target.value
                                        );
                                        validatepersonalphysician();
                                        handleDisableBtn();
                                    }}
                                    error={personalphysicianNoError.length > 0 ? true : false}
                                    helperText={
                                        personalphysicianNoError.length > 0 ? personalphysicianNoError : ''
                                    }
                                />
                            </Grid>
                            <Grid item lg={4} md={4} xs={12}>
                                <TextField
                                    fullWidth
                                    size="small"
                                    id="outlined-basic"
                                    onChange={(event) => {
                                        state.personalphysicianEmail.set(
                                            event.target.value
                                        );
                                        validatePersonalPhysicianContactEmail()
                                        handleDisableBtn()
                                    }
                                    }
                                    variant="outlined"
                                    disabled={!checkEditPermission}
                                    label="Personal Physician Email"
                                    inputProps={{ maxLength: 255 }}
                                    value={state.personalphysicianEmail.get()}
                                    error={personalphysicianEmailError.length > 0 ? true : false}
                                    helperText={
                                        personalphysicianEmailError.length > 0 ? personalphysicianEmailError : ''
                                    }
                                />
                            </Grid>
                            <Grid item lg={4} md={4} xs={12}>
                                <PhoneNumber
                                    name={'combineRegistrationContact'}
                                    placeholder={
                                        state.eventForm.get() !== null &&
                                            state.eventForm
                                                .get()
                                                .FormFields.find(
                                                    (x) =>
                                                        x.FieldValue === true &&
                                                        x.FieldName === 'NotAttend'
                                                )
                                            ? 'Personal Physician Contact No'
                                            : 'Personal Physician Contact No'
                                    }
                                    value={state.personalphysicianContactNo.get()}
                                    onChange={(event) => {
                                        state.personalphysicianContactNo.set(
                                            event
                                        );
                                        validatePersonalPhysicianContactNo()
                                        handleDisableBtn()
                                    }
                                    }
                                    disabled={
                                        !checkEditPermission
                                            ? !checkEditPermission
                                            : params.userID > 0
                                                ? true
                                                : false
                                    }
                                    error={personalphysicianContactNoError.length > 0 ? true : false}
                                    helperText={
                                        personalphysicianContactNoError.length > 0 ? personalphysicianContactNoError : ''
                                    }
                                />
                            </Grid>
                        </Grid>
                    </Box>
                    {/* <Divider
                    light={false}
                    sx={{ mt: 2, marginRight: 0, mb: 2 }}
                    flexItem
                /> */}
                    <Grid sx={{ padding: 0 }}>
                        {/* <AppBar position="static" color="default" sx={appBarStyle}>
                        <Title
                            title={'HEALTH RELATED INFORMATION'}
                            // addicon="land"
                            sx={{
                                ml: 1,
                                mt:0.5,
                            }}
                        />
                    </AppBar> */}
                        {/* <Typography>HEALTH RELATED INFORMATION</Typography> */}
                        {/* <Grid sx={{ background: '#FFCCCB', my: 2 }}>
                        <Typography
                            sx={{
                                color: '',
                                padding: '.5rem',
                                fontSize: 14,
                            }}>
                            {' '}
                            The information below is required in accordance with
                            NBA Health and Safety Protocals. Please ensure this
                            section is filled out accurately
                        </Typography>
                    </Grid> */}
                        {/* <Box sx={{ width: '100%' }}>
                         <Grid
                            container
                            rowSpacing={1}
                            columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                            <Grid item lg={4} md={4} xs={12}>
                                <FormControl
                                    disabled={!checkEditPermission}
                                    fullWidth
                                    size="small">
                                    <InputLabel id="demo-simple-select-label">
                                        Sex
                                    </InputLabel>
                                    <Select
                                        labelId="demo-simple-select-label"
                                        id="demo-simple-select"
                                        value={state.sex.get()}
                                        input={<OutlinedInput label="Sex *" />}
                                        sx={{ minWidth: '40%' }}
                                        onChange={(event) =>
                                            state.sex.set(event.target.value)
                                        }>
                                        {sex &&
                                            sex.map((option) => (
                                                <MenuItem
                                                    key={option.value}
                                                    value={option.value}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item lg={4} md={4} xs={12}>

                            </Grid>
                            <Grid item lg={4} md={4} xs={12}>
                                <FormControl fullWidth disabled={!checkEditPermission} variant='outlined' size="small">
                                    <InputLabel id="Vaccinated-select-small">Are You Vaccinated ? *</InputLabel>
                                    <Select
                                        labelId="Vaccinated-select-small"
                                        id="demo-select-small"
                                        required
                                        value={`${state.vaccinated.get() ?? ""}`}
                                        label="Are You Vaccinated ? *"
                                        sx={{ minWidth: '40%' }}
                                        onChange={(event) =>
                                            state.vaccinated.set(
                                                parseInt(event.target.value)
                                            )
                                        }
                                    >
                                        {vaccinated &&
                                            vaccinated.map((option) => (
                                                <MenuItem
                                                    key={option.value}
                                                    value={`${option.value}`}>
                                                    {option.label}
                                                </MenuItem>
                                            ))}
                                    </Select>
                                </FormControl>

                            </Grid>
                        </Grid> 
                    </Box>*/}
                    </Grid>
                    {/* <Grid sx={{ padding: '16px 0' }}>
                    <Grid px={2}>

                        <ListItem>
                            Prior to attending the 2022 NBA Draft Combine or G League Elite Camp, all players must document their vaccination status with the NBA
                            by completing this survey via the link below. Please contact the NBA with any questions.

                        </ListItem>
                        <Link sx={{ pl: 2 }} variant='body2' target='_blank' href="https://tmbo.iad1.qualtrics.com/jfe/form/SV_0O0EGK0hNcNw33g">https://tmbo.iad1.qualtrics.com/jfe/form/SV_0O0EGK0hNcNw33g</Link>


                    </Grid> */}
                    {/* <Typography fontWeight={600}>
                        Fully Vaccinated against COVID-19 means that:
                    </Typography>
                    <Grid px={2}>
                        <ul>
                            <ListItem>
                                <li>
                                    14 days have passed since a person recieved
                                    a dose of an accepted one dose COVID-19
                                    vaccine.
                                </li>
                            </ListItem>
                            <ListItem>
                                <li>
                                    14 days have passed since a person recieved
                                    their second dose of an accepted two dose
                                    COVID-19 vaccine series or a complete series
                                    of a vaccine.
                                </li>
                            </ListItem>
                        </ul>
                    </Grid>
                    <Typography fontWeight={600}>
                        &quot;F NBA-accepted vaccines for the definition of
                        &quot;fully vaccinated&quot; are
                    </Typography>
                    <Grid px={2}>
                        <ul>
                            <ListItem>
                                <li>
                                    A vaccine approved (or authorized for
                                    emergency use) by the U.S.FDA.
                                </li>
                            </ListItem>
                            <ListItem>
                                <li>
                                    A vaccine approved(or licensed for emergency
                                    use) by WHO.
                                </li>
                            </ListItem>
                            <ListItem>
                                <li>
                                    A combination of vaccines(&quot;mix and
                                    match&quot;) as listed by the U.S. CDC.
                                </li>
                            </ListItem>
                        </ul>
                    </Grid>
                    <Typography fontWeight={600}>Additional Notes</Typography>
                    <Grid px={2}>
                        <ul>
                            <ListItem>
                                <li>
                                    Documentation of vaccination history will be
                                    required and must be provided to NBA.
                                </li>
                            </ListItem>
                            <ListItem>
                                <li>
                                    Booster dose may be required to meet the
                                    definition of &quot;fully vaccinated&quot;
                                    if public health recommendations are updated
                                    in future based on a changing COVID-19
                                    epidemiologic situation.
                                </li>
                            </ListItem>
                            <ListItem>
                                <li>
                                    Individuals who are recommended to recieve a
                                    COVID-19 booster dose(or doses) according to
                                    the U.S.CDC or their own country&ldquo;s
                                    criteria are strongly urged to recieve a
                                    booster dose unless medically
                                    contraindicated for the individual.
                                </li>
                            </ListItem>
                            <ListItem>
                                <li>
                                    Being &quot;fully vaccinated&quot; may not
                                    be provide additional testing requirements
                                    at specific events and locations as directed
                                    by the NBA.
                                </li>
                            </ListItem>
                        </ul>
                    </Grid> 
                </Grid>*/}
                    {checkEditPermission ? (
                        <>
                            <Divider
                                light={false}
                                sx={{
                                    mt: 2,
                                    marginRight: 0,
                                    mb: 2,
                                    background: 'blue',
                                }}
                                flexItem
                            />
                            <Stack
                                spacing={2}
                                direction="row-reverse"
                                sx={{ m: 1 }}>
                                {props.loading.get() ? (
                                    <Button variant="contained" disabled>
                                        <CircularProgress
                                            size={20}
                                            color="grey"
                                            style={{ position: 'absolute' }}
                                        />
                                        {state.addedFor.get() > 0 &&
                                            !props.showSaveAsDraftBtn
                                            ? 'Update'
                                            : 'Submit'}
                                    </Button>
                                ) : (
                                    <Button
                                        variant="contained"
                                        onClick={handleClick}
                                        disabled={
                                            Helper.isAdminUser(userInfo) ||
                                                (userInfo.roles &&
                                                    Helper.isEventAdmin(userInfo))
                                                ? disableBtn === true
                                                    ? true
                                                    : false
                                                : eventInfo.readonlyOrHide === 1
                                                    ? true
                                                    : !checkEditPermission
                                                        ? true
                                                        : (state.requestStatus.get() ==='0' || state.requestStatus.get() ==='' || state.requestStatus.get() === undefined) ? false : disableBtn
                                        }>
                                        {(state.addedFor.get() > 0  && state.requestStatus.get() !=='0')
                                            ? 'Update'
                                            : 'Submit'}
                                    </Button>
                                )}
                                {props.showSaveAsDraftBtn ? (
                                    <Button
                                        variant="outlined"
                                        onClick={handleSaveAsDraft}
                                        disabled={(state.requestStatus.get() ==='0' || state.requestStatus.get() ==='' || state.requestStatus.get() ===undefined) ? false : 
                                            disableDraftBtn || saveAsDraftLoader
                                        }>
                                        {saveAsDraftLoader ? (
                                            <CircularProgress
                                                size={20}
                                                color="grey"
                                                style={{ position: 'absolute' }}
                                            />
                                        ) : null}
                                        Save As Draft
                                    </Button>
                                ) : null}
                                {(Helper.isAdminUser(userInfo) ||
                                    (userInfo.roles && Helper.isEventAdmin(userInfo)) || (userInfo.roles && Helper.isEventStaff(userInfo))
                                )? (
                                    <Button
                                        variant="outlined"
                                        onClick={handleCancelReq}>
                                        Cancel
                                    </Button>
                                ) : null}
                            </Stack>
                        </>
                    ) : null}
                </Box>
                {/* </Paper> */}
                {/* </Paper> */}
                {snackBarProps.openSnack && (
                    <CustomizedSnackbars
                        {...snackBarProps}
                        onClose={() =>
                            setSnackBarProps({
                                ...snackBarProps,
                                openSnack: false,
                            })
                        }></CustomizedSnackbars>
                )}
                {openUpload.get() && (
                    <UploadImagePopup
                        open={openUpload.get()}
                        // setViewFile={setViewFile}
                        title="Upload Image"
                        handleClose={handleClose}
                        changeProfilePhoto={changeProfilePhoto}
                        snackBarProps={snackBarProps}
                        setSnackBarProps={setSnackBarProps}
                        showExtraDescription={true}
                    />
                )}
                {openFamilyMemberUpload.get() && (
                    <UploadImagePopup
                        open={openFamilyMemberUpload.get()}
                        // setViewFile={setViewFile}
                        title="Upload Image"
                        handleClose={handleFamilyMemebrClose}
                        changeProfilePhoto={changeFamilyMemberProfilePhoto}
                        snackBarProps={snackBarProps}
                        setSnackBarProps={setSnackBarProps}
                        showExtraDescription={true}
                    />
                )}
                <Backdrop
                    sx={{
                        color: '#fff',
                        zIndex: (theme) => theme.zIndex.drawer + 150,
                    }}
                    open={openBackdrop}
                //onClick={handleCloseBackDrop}
                >
                    <CircularProgress color="inherit" />
                </Backdrop>

                <RouterPrompt
                    key="CombineRegistration"
                    when={dirty}
                    title="Leave this page"
                    cancelText="No"
                    okText="Yes"
                    onOK={handleSaveAsDraftOnPromptConfirm}
                    onCancel={handleCancelConfirmation}
                    message="There are unsaved changes. Do you want to save it?"
                />
            </Box>
        </Box>
    );
};

export default EventRegistration;
